<template>
  <div class="main-content">
    <!-- HEADER -->
    <div class="header">
      <div class="container-fluid">
        <!-- Card -->
        <!-- <div class="card mt-5">
          <div class="card-body">
            <div class="row justify-content-between align-items-center">
              <div class="col-12 col-md-9 col-xl-7">
                <div class="mb-2">
                  <span>My Teams IDP</span>
                  <span class="text-muted ml-2">></span>
                  <span class="text-danger ml-2">{{ activeTabTitle }}</span>
                </div>

                <p class="text-muted mb-md-0">This is My Teams IDP menu</p>
              </div>
            </div>
          </div>
        </div> -->
        <!-- My IDP dll -->
        <div class="card mt-5">
          <div class="card-header">
            <span class="mt-3 fs-2">IDP Examination</span>
            <!-- <b-button
              v-if="currentTab === 1"
              class="btn btn-primary"
              variant="primary"
              v-b-modal.modal-training-aspiration>
              <span class="fe fe-plus-circle"></span>
              Add Training
            </b-button> -->
          </div>
          <div class="card-body">
            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg-2">
                  <h5 class="fw-bold mt-5">Company</h5>
                </div>
                <div class="col-4">
                  <v-select
                    v-model="bodySearch.company"
                    :options="bussinessUnit"
                    class="mt-4"
                    placeholder="Select Company"
                    @input="onBussinessUnitSelected('company')">
                  </v-select>
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <h5 class="fw-bold mt-5">Directorate</h5>
                </div>
                <div class="col-4">
                  <v-select
                    :disabled="bodySearch.company ? false : true"
                    v-model="bodySearch.directorate"
                    :options="bussinessUnit2"
                    class="mt-4"
                    placeholder="Select Directorate"
                    @input="onBussinessUnitSelected('dir')">
                  </v-select>
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <h5 class="fw-bold mt-5">Division</h5>
                </div>
                <div class="col-4">
                  <v-select
                    v-model="bodySearch.division"
                    :disabled="
                      bodySearch.company && bodySearch.directorate
                        ? false
                        : true
                    "
                    :options="bussinessUnit3"
                    class="mt-4"
                    placeholder="Select Division"
                    @input="onBussinessUnitSelected('div')">
                  </v-select>
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <h5 class="fw-bold mt-5">Department</h5>
                </div>
                <div class="col-4">
                  <v-select
                    v-model="bodySearch.department"
                    :disabled="
                      bodySearch.company &&
                      bodySearch.directorate &&
                      bodySearch.division
                        ? false
                        : true
                    "
                    :options="bussinessUnit4"
                    class="mt-4"
                    placeholder="Select Department"
                    @input="onBussinessUnitSelected('dept')">
                  </v-select>
                </div>
              </div>
            </div>
            <!-- <div
                class="d-flex justify-content-end mt-5"
                v-if="isLoadingFilter == false">
                <b-button
                  class="mr-2"
                  variant="outline-primary"
                  @click="resetFilterHR()"
                  >Clear Filter</b-button
                >
                <b-button variant="primary" @click="getHrData()"
                  >Filter</b-button
                >
              </div> -->
            <!-- <div class="d-flex justify-content-end mt-5" v-else>
                <b-skeleton type="button" class="mr-2"></b-skeleton>
                <b-skeleton type="button"></b-skeleton>
              </div> -->
            <div class="col-lg-12 mt-5">
              <div class="row mt-4">
                <div class="col-lg-2">
                  <p class="small mt-2">
                    <strong>Name</strong>
                  </p>
                </div>
                <div class="col-4">
                  <!-- {{listKaryawan}} -->
                  <v-select
                    v-model="employee"
                    :options="listKaryawan"
                    :reduce="(e) => e"
                    label="employee_name"
                    placeholder="Select Employee"
                    @input="selectEmployee">
                  </v-select>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-lg-2">
                  <p class="small mt-2">
                    <strong>NIK</strong>
                  </p>
                </div>
                <div class="col-4">
                  {{ nik || "-" }}
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-lg-2">
                  <p class="small mt-2">
                    <strong>Position</strong>
                  </p>
                </div>
                <div class="col-4">
                  {{ position || "-" }}
                </div>
              </div>
            </div>
            <div class="d-flex">
              <div class="rectangle filled-danger mt-3"></div>
              <span class="ml-2 mt-2">: Below Proficiency Standard</span>
              <div class="rectangle filled-target mt-3 ml-3"></div>
              <span class="ml-2 mt-2">: Meet Proficiency Standard</span>
              <div class="rectangle filled-achievement mt-3 ml-3"></div>
              <span class="ml-2 mt-2">: Above Proficiency Standard</span>
              <b-button
                v-if="this.nik"
                v-b-modal.modal-loading
                class="btn btn-primary ml-auto mt-5"
                variant="primary"
                title="Export IDP Report"
                @click="exportPdf">
                <span class="fe fe-download"></span>
                IDP Report
              </b-button>
              <b-button
                v-if="this.nik && this.roleLogin != 'Assessor'"
                class="btn btn-primary ml-2 mt-5"
                variant="primary"
                title="Export Bulk Approved"
                @click="bulkApproved">
                <span class="fe fe-save"></span>
                Bulk Approved
              </b-button>
            </div>
          </div>
          <b-tabs class="px-4">
            <b-tab title="All">
              <div class="table-responsive">
                <table class="table table-sm table-bordered table-nowrap mt-4">
                  <thead>
                    <tr class="">
                      <th rowspan="2">Competency</th>
                      <th rowspan="2">Proficiency Standard</th>
                      <th rowspan="2">Assessment Result</th>
                      <th rowspan="2">Gap</th>
                      <th rowspan="2">IDP</th>
                      <th class="text-center" rowspan="2">IDP Status</th>
                      <th rowspan="2">Examination Result</th>
                      <th rowspan="2">New Gap</th>
                      <th rowspan="2">Status</th>
                      <th rowspan="2">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="paginatedItems.length > 0">
                    <tr v-for="(item, index) in paginatedItems" :key="index">
                      <td class="text-center">
                        {{ item.competency_name }}
                      </td>
                      <td class="text-center">
                        {{ item.proficiency_standard }}
                      </td>
                      <td class="text-center">{{ item.proficiency }}</td>
                      <td class="text-center">
                        <span
                          v-if="item.proficiency_difference !== null"
                          :class="getBadgeGapExam(item.proficiency_difference)">
                          {{
                            item.proficiency_difference > 0
                              ? "" + item.proficiency_difference
                              : item.proficiency_difference
                          }}
                        </span>
                      </td>
                      <td>
                        <ul class="list-unstyled mb-0">
                          <li
                            class="mb-3"
                            v-for="(learning, lIndex) in item.items"
                            :key="lIndex">
                            {{
                              learning.learning.name || learning.learning.title
                            }}
                          </li>
                        </ul>
                      </td>
                      <td>
                        <ul class="list-unstyled mb-0">
                          <li
                            class="mb-3"
                            v-for="(learning, lIndex) in item.items"
                            :key="lIndex">
                            <span
                              :class="getBadgeStatus(learning.learning.status)">
                              <i
                                :class="getIconClass(learning.learning.status)"
                                class="me-1"></i>
                              {{ capitalizeStatus(learning.learning.status) }}
                            </span>
                          </li>
                        </ul>
                      </td>
                      <td class="text-center">
                        <span
                          v-if="item.proficiency_new !== null"
                          :class="
                            getBadgeResult(
                              item.proficiency_new,
                              item.proficiency_standard
                            )
                          ">
                          {{
                            item.proficiency_new > 0
                              ? "" + item.proficiency_new
                              : item.proficiency_new
                          }}
                        </span>
                        <!-- {{ item.proficiency_new !== null ? item.proficiency_new : "-" }} -->
                      </td>
                      <td class="text-center">
                        <span
                          v-if="item.proficiency_difference_new !== null"
                          :class="
                            getBadgeGapExam(item.proficiency_difference_new)
                          ">
                          {{ Math.abs(item.proficiency_difference_new) }}
                        </span>
                      </td>
                      <td>
                        <div v-if="item.isCompleted && item.status ===null">
                          <span :class="getBadgeStatus('process')">
                            <i
                              :class="getIconClass('process')"
                              class="me-1"></i>
                            Process
                          </span>
                        </div>
                        <div v-else>
                          <span
                            :class="getBadgeStatus(item.status)">
                            <i
                              :class="getIconClass(item.status)"
                              class="me-1"></i>
                            {{ capitalizeStatus(item.status) }}
                          </span>
                        </div>
                      </td>
                      <td class="text-center">
                        <button
                          v-if="
                          item.items && 
                          item.items.length > 0 &&
                          item.isCompleted && 
                          item.status !== 'Approved' &&
                          item.status !== 'Review' &&
                          listTabMenu.privilages.update
                        "
                          @click="editProficiency(item)"
                          class="btn btn-sm btn-warning mx-2"
                          v-b-tooltip.hover="'Edit Proficiency'">
                          <span class="fe fe-edit"></span>
                        </button>
                         <button
                          v-if="
                            item.items && 
                            item.items.length > 0 && 
                            item.feedback !== null &&
                            listTabMenu.privilages.read
                          "
                          class="btn btn-sm btn-info mx-1 my-1"
                          @click="viewFeedback(item)"
                          v-b-tooltip.hover="'View Feedback'">
                          <span class="fe fe-eye"></span>
                        </button>
                        <!-- <button
                          v-if="
                            item.items && 
                            item.items.length > 0 &&
                            item.isCompleted &&
                            !item.feedback &&
                            listTabMenu.privilages.create
                          "
                          class="btn btn-sm btn-success mx-1 my-1"
                          @click="addFeedback(item)"
                          v-b-tooltip.hover="'Add Feedback'">
                          <span class="fe fe-message-square"></span>
                        </button> -->
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td class="text-center" colspan="12">
                        No Data Available
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="pagination-controls">
                  <label for="itemsPerPage">Items per page:</label>
                  <select id="itemsPerPage" v-model="itemsPerPage">
                    <option
                      v-for="option in itemsPerPageOptions"
                      :key="option"
                      :value="option">
                      {{ option }}
                    </option>
                  </select>
                </div>
                <div class="pagination">
                  <button @click="prevPage" :disabled="currentPage === 1">
                    Previous
                  </button>
                  <span>Page {{ currentPage }} of {{ totalPages }}</span>
                  <button
                    @click="nextPage"
                    :disabled="currentPage === totalPages">
                    Next
                  </button>
                </div>
              </div>
            </b-tab>
            <b-tab title="Structured Learning">
              <div class="table-responsive">
                <table class="table table-sm table-bordered table-nowrap mt-4">
                  <thead>
                    <tr class="">
                      <th rowspan="2">Competency</th>
                      <th rowspan="2">Proficiency Standard</th>
                      <th rowspan="2">Assessment Result</th>
                      <th rowspan="2">Gap</th>
                      <th rowspan="2">IDP</th>
                      <th class="text-center" rowspan="2">IDP Status</th>
                      <th rowspan="2">Examination Result</th>
                      <th rowspan="2">New Gap</th>
                      <th rowspan="2">Status</th>
                      <th rowspan="2">Action</th>
                    </tr>
                  </thead>
                  <tbody
                    v-if="
                      idpExamination.structured
                        ? idpExamination.structured.length > 0
                        : false
                    ">
                    <tr
                      v-for="(item, index) in idpExamination.structured"
                      :key="index">
                      <td class="text-center">
                        {{ item.competency_name }}
                      </td>
                      <td class="text-center">
                        {{ item.proficiency_standard }}
                      </td>
                      <td class="text-center">{{ item.proficiency }}</td>
                      <td class="text-center">
                        <span
                          v-if="item.proficiency_difference !== null"
                          :class="getBadgeGapExam(item.proficiency_difference)">
                          {{
                            item.proficiency_difference > 0
                              ? "" + item.proficiency_difference
                              : item.proficiency_difference
                          }}
                        </span>
                      </td>
                      <td>
                        <ul class="list-unstyled mb-0">
                          <li
                            class="mb-3"
                            v-for="(learning, lIndex) in item.items"
                            :key="lIndex">
                            {{
                              learning.learning.name || learning.learning.title
                            }}
                          </li>
                        </ul>
                      </td>
                      <td>
                        <ul class="list-unstyled mb-0">
                          <li
                            class="mb-3"
                            v-for="(learning, lIndex) in item.items"
                            :key="lIndex">
                            <span
                              :class="getBadgeStatus(learning.learning.status)">
                              <i
                                :class="getIconClass(learning.learning.status)"
                                class="me-1"></i>
                              {{ capitalizeStatus(learning.learning.status) }}
                            </span>
                          </li>
                        </ul>
                      </td>
                      <td class="text-center">
                        <span
                          v-if="item.proficiency_new !== null"
                          :class="
                            getBadgeResult(
                              item.proficiency_new,
                              item.proficiency_standard
                            )
                          ">
                          {{
                            item.proficiency_new > 0
                              ? "" + item.proficiency_new
                              : item.proficiency_new
                          }}
                        </span>
                        <!-- {{ item.proficiency_new !== null ? item.proficiency_new : "-" }} -->
                      </td>
                      <td class="text-center">
                        <span
                          v-if="item.proficiency_difference_new !== null"
                          :class="
                            getBadgeGapExam(item.proficiency_difference_new)
                          ">
                          {{ Math.abs(item.proficiency_difference_new) }}
                        </span>
                      </td>
                      <td>
                        <div v-if="item.isCompleted && item.status ===null">
                          <span :class="getBadgeStatus('process')">
                            <i
                              :class="getIconClass('process')"
                              class="me-1"></i>
                            Process
                          </span>
                        </div>
                        <div v-else>
                          <span
                            :class="getBadgeStatus(item.status)">
                            <i
                              :class="getIconClass(item.status)"
                              class="me-1"></i>
                            {{ capitalizeStatus(item.status) }}
                          </span>
                        </div>
                      </td>
                      <td class="text-center">
                        <button
                          v-if="
                          item.items && 
                          item.items.length > 0 &&
                          item.isCompleted && 
                          item.status !== 'Approved' &&
                          item.status !== 'Review' &&
                          listTabMenu.privilages.update
                        "
                          @click="editProficiency(item)"
                          class="btn btn-sm btn-warning mx-2"
                          v-b-tooltip.hover="'Edit Proficiency'">
                          <span class="fe fe-edit"></span>
                        </button>
                         <button
                          v-if="
                            item.items && 
                            item.items.length > 0 && 
                            item.feedback !== null &&
                            listTabMenu.privilages.read
                          "
                          class="btn btn-sm btn-info mx-1 my-1"
                          @click="viewFeedback(item)"
                          v-b-tooltip.hover="'View Feedback'">
                          <span class="fe fe-eye"></span>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td class="text-center" colspan="12">
                        No Data Available
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-- <div class="pagination-controls">
                  <label for="itemsPerPage">Items per page:</label>
                  <select id="itemsPerPage" v-model="itemsPerPage">
                    <option
                      v-for="option in itemsPerPageOptions"
                      :key="option"
                      :value="option">
                      {{ option }}
                    </option>
                  </select>
                </div>
                <div class="pagination">
                  <button @click="prevPage" :disabled="currentPage === 1">
                    Previous
                  </button>
                  <span>Page {{ currentPage }} of {{ totalPages }}</span>
                  <button
                    @click="nextPage"
                    :disabled="currentPage === totalPages">
                    Next
                  </button>
                </div> -->
              </div>
            </b-tab>
            <b-tab title="Social Learning">
              <div class="table-responsive">
                <table class="table table-sm table-bordered table-nowrap mt-4">
                  <thead>
                    <tr class="">
                      <th rowspan="2">Competency</th>
                      <th rowspan="2">Proficiency Standard</th>
                      <th rowspan="2">Assessment Result</th>
                      <th rowspan="2">Gap</th>
                      <th rowspan="2">IDP</th>
                      <th class="text-center" rowspan="2">IDP Status</th>
                      <th rowspan="2">Examination Result</th>
                      <th rowspan="2">New Gap</th>
                      <th rowspan="2">Status</th>
                      <th rowspan="2">Action</th>
                    </tr>
                  </thead>
                  <tbody
                    v-if="
                      idpExamination.social
                        ? idpExamination.social.length > 0
                        : false
                    ">
                    <tr
                      v-for="(item, index) in idpExamination.social"
                      :key="index">
                      <td class="text-center">
                        {{ item.competency_name }}
                      </td>
                      <td class="text-center">
                        {{ item.proficiency_standard }}
                      </td>
                      <td class="text-center">{{ item.proficiency }}</td>
                      <td class="text-center">
                        <span
                          v-if="item.proficiency_difference !== null"
                          :class="getBadgeGapExam(item.proficiency_difference)">
                          {{
                            item.proficiency_difference > 0
                              ? "" + item.proficiency_difference
                              : item.proficiency_difference
                          }}
                        </span>
                      </td>
                      <td>
                        <ul class="list-unstyled mb-0">
                          <li
                            class="mb-3"
                            v-for="(learning, lIndex) in item.items"
                            :key="lIndex">
                            {{
                              learning.learning.name || learning.learning.title
                            }}
                          </li>
                        </ul>
                      </td>
                      <td>
                        <ul class="list-unstyled mb-0">
                          <li
                            class="mb-3"
                            v-for="(learning, lIndex) in item.items"
                            :key="lIndex">
                            <span
                              :class="getBadgeStatus(learning.learning.status)">
                              <i
                                :class="getIconClass(learning.learning.status)"
                                class="me-1"></i>
                              {{ capitalizeStatus(learning.learning.status) }}
                            </span>
                          </li>
                        </ul>
                      </td>
                      <td class="text-center">
                        <span
                          v-if="item.proficiency_new !== null"
                          :class="
                            getBadgeResult(
                              item.proficiency_new,
                              item.proficiency_standard
                            )
                          ">
                          {{
                            item.proficiency_new > 0
                              ? "" + item.proficiency_new
                              : item.proficiency_new
                          }}
                        </span>
                        <!-- {{ item.proficiency_new !== null ? item.proficiency_new : "-" }} -->
                      </td>
                      <td class="text-center">
                        <span
                          v-if="item.proficiency_difference_new !== null"
                          :class="
                            getBadgeGapExam(item.proficiency_difference_new)
                          ">
                          {{ Math.abs(item.proficiency_difference_new) }}
                        </span>
                      </td>
                      <td>
                        <div v-if="item.isCompleted && item.status ===null">
                          <span :class="getBadgeStatus('process')">
                            <i
                              :class="getIconClass('process')"
                              class="me-1"></i>
                            Process
                          </span>
                        </div>
                        <div v-else>
                          <span
                            :class="getBadgeStatus(item.status)">
                            <i
                              :class="getIconClass(item.status)"
                              class="me-1"></i>
                            {{ capitalizeStatus(item.status) }}
                          </span>
                        </div>
                      </td>
                      <td class="text-center">
                        <button
                          v-if="
                          item.items && 
                          item.items.length > 0 &&
                          item.isCompleted && 
                          item.status !== 'Approved' &&
                          item.status !== 'Review' &&
                          listTabMenu.privilages.update
                        "
                          @click="editProficiency(item)"
                          class="btn btn-sm btn-warning mx-2"
                          v-b-tooltip.hover="'Edit Proficiency'">
                          <span class="fe fe-edit"></span>
                        </button>
                         <button
                          v-if="
                            item.items && 
                            item.items.length > 0 && 
                            item.feedback !== null &&
                            listTabMenu.privilages.read
                          "
                          class="btn btn-sm btn-info mx-1 my-1"
                          @click="viewFeedback(item)"
                          v-b-tooltip.hover="'View Feedback'">
                          <span class="fe fe-eye"></span>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td class="text-center" colspan="12">
                        No Data Available
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-- <div class="pagination-controls">
                  <label for="itemsPerPage">Items per page:</label>
                  <select id="itemsPerPage" v-model="itemsPerPage">
                    <option
                      v-for="option in itemsPerPageOptions"
                      :key="option"
                      :value="option">
                      {{ option }}
                    </option>
                  </select>
                </div>
                <div class="pagination">
                  <button @click="prevPage" :disabled="currentPage === 1">
                    Previous
                  </button>
                  <span>Page {{ currentPage }} of {{ totalPages }}</span>
                  <button
                    @click="nextPage"
                    :disabled="currentPage === totalPages">
                    Next
                  </button>
                </div> -->
              </div>
            </b-tab>
            <b-tab title="Experiential Learning">
              <div class="table-responsive">
                <table class="table table-sm table-bordered table-nowrap mt-4">
                  <thead>
                    <tr class="">
                      <th rowspan="2">Competency</th>
                      <th rowspan="2">Proficiency Standard</th>
                      <th rowspan="2">Assessment Result</th>
                      <th rowspan="2">Gap</th>
                      <th rowspan="2">IDP</th>
                      <th class="text-center" rowspan="2">IDP Status</th>
                      <th rowspan="2">Examination Result</th>
                      <th rowspan="2">New Gap</th>
                      <th rowspan="2">Status</th>
                      <th rowspan="2">Action</th>
                    </tr>
                  </thead>
                  <tbody
                    v-if="
                      idpExamination.experential
                        ? idpExamination.experential.length > 0
                        : false
                    ">
                    <tr
                      v-for="(item, index) in idpExamination.experential"
                      :key="index">
                      <td class="text-center">
                        {{ item.competency_name }}
                      </td>
                      <td class="text-center">
                        {{ item.proficiency_standard }}
                      </td>
                      <td class="text-center">{{ item.proficiency }}</td>
                      <td class="text-center">
                        <span
                          v-if="item.proficiency_difference !== null"
                          :class="getBadgeGapExam(item.proficiency_difference)">
                          {{
                            item.proficiency_difference > 0
                              ? "" + item.proficiency_difference
                              : item.proficiency_difference
                          }}
                        </span>
                      </td>
                      <td>
                        <ul class="list-unstyled mb-0">
                          <li
                            class="mb-3"
                            v-for="(learning, lIndex) in item.items"
                            :key="lIndex">
                            {{
                              learning.learning.name || learning.learning.title
                            }}
                          </li>
                        </ul>
                      </td>
                      <td>
                        <ul class="list-unstyled mb-0">
                          <li
                            class="mb-3"
                            v-for="(learning, lIndex) in item.items"
                            :key="lIndex">
                            <span
                              :class="getBadgeStatus(learning.learning.status)">
                              <i
                                :class="getIconClass(learning.learning.status)"
                                class="me-1"></i>
                              {{ capitalizeStatus(learning.learning.status) }}
                            </span>
                          </li>
                        </ul>
                      </td>
                      <td class="text-center">
                        <span
                          v-if="item.proficiency_new !== null"
                          :class="
                            getBadgeResult(
                              item.proficiency_new,
                              item.proficiency_standard
                            )
                          ">
                          {{
                            item.proficiency_new > 0
                              ? "" + item.proficiency_new
                              : item.proficiency_new
                          }}
                        </span>
                        <!-- {{ item.proficiency_new !== null ? item.proficiency_new : "-" }} -->
                      </td>
                      <td class="text-center">
                        <span
                          v-if="item.proficiency_difference_new !== null"
                          :class="
                            getBadgeGapExam(item.proficiency_difference_new)
                          ">
                          {{ Math.abs(item.proficiency_difference_new) }}
                        </span>
                      </td>
                      <td>
                        <div v-if="item.isCompleted && item.status ===null">
                          <span :class="getBadgeStatus('process')">
                            <i
                              :class="getIconClass('process')"
                              class="me-1"></i>
                            Process
                          </span>
                        </div>
                        <div v-else>
                          <span
                            :class="getBadgeStatus(item.status)">
                            <i
                              :class="getIconClass(item.status)"
                              class="me-1"></i>
                            {{ capitalizeStatus(item.status) }}
                          </span>
                        </div>
                      </td>
                      <td class="text-center">
                        <button
                          v-if="
                          item.items && 
                          item.items.length > 0 &&
                          item.isCompleted && 
                          item.status !== 'Approved' &&
                          item.status !== 'Review' &&
                          listTabMenu.privilages.update
                        "
                          @click="editProficiency(item)"
                          class="btn btn-sm btn-warning mx-2"
                          v-b-tooltip.hover="'Edit Proficiency'">
                          <span class="fe fe-edit"></span>
                        </button>
                         <button
                          v-if="
                            item.items && 
                            item.items.length > 0 && 
                            item.feedback !== null &&
                            listTabMenu.privilages.read
                          "
                          class="btn btn-sm btn-info mx-1 my-1"
                          @click="viewFeedback(item)"
                          v-b-tooltip.hover="'View Feedback'">
                          <span class="fe fe-eye"></span>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td class="text-center" colspan="12">
                        No Data Available
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-- <div class="pagination-controls">
                  <label for="itemsPerPage">Items per page:</label>
                  <select id="itemsPerPage" v-model="itemsPerPage">
                    <option
                      v-for="option in itemsPerPageOptions"
                      :key="option"
                      :value="option">
                      {{ option }}
                    </option>
                  </select>
                </div>
                <div class="pagination">
                  <button @click="prevPage" :disabled="currentPage === 1">
                    Previous
                  </button>
                  <span>Page {{ currentPage }} of {{ totalPages }}</span>
                  <button
                    @click="nextPage"
                    :disabled="currentPage === totalPages">
                    Next
                  </button>
                </div> -->
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
    <!-- MODAL HERE -->
    <b-modal
      id="modal-loading"
      size="sm"
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
      no-close-on-esc>
      <b class="d-flex justify-content-center mb-3">Please wait</b>
      <div class="d-flex justify-content-center">
        <b-spinner variant="primary" label="Loading"></b-spinner>
      </div>
    </b-modal>
    <b-modal
      v-model="isEditProficiency"
      title="Verify Current Competency Proficiency after IDP"
      size="lg"
      hide-footer>
      <div class="form-group">
        <div class="row">
          <!-- Kompetensi -->
          <div class="row justify-content-center mb-4">
            <div class="col-12">
              <table class="table table-bordered text-center">
                <thead class="table-light">
                  <tr>
                    <th>Competency</th>
                    <th>Old Proficiency</th>
                    <th>Standart Proficiency</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ bodyProficiency.competency }}</td>
                    <td>{{ bodyProficiency.old_proficiency }}</td>
                    <td>{{ bodyProficiency.standartd_proficiency }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Proficiency Saat Ini -->
          <div class="col-md-6 col-12 mb-3">
            <label class="form-label">New Proficiency</label>
            <input
              v-model="bodyProficiency.proficiency"
              type="number"
              class="form-control"
              placeholder="Nilai Saat Ini" />
          </div>

          <!-- Feedback (textarea) -->
          <div class="col-md-6 col-12 mb-3">
            <label class="form-label">Feedback</label>
            <textarea
              v-model="bodyProficiency.feedback"
              class="form-control"
              rows="4"
              placeholder="Tulis feedback lebih lengkap..."></textarea>
          </div>
        </div>
      </div>
      <b-button
        class="float-end"
        variant="primary"
        @click="submitEditProficiency()"
        >Submit
      </b-button>
    </b-modal>
    <!-- Modal Edit Activities -->
    <b-modal
      v-model="isEditActivities"
      title="Edit Project Activities"
      size="lg"
      hide-footer
      @hide="clearBodyActivities">
      <div class="form-group">
        <div class="row">
          <div class="col-12 mt-4">
            <label class="form-label">Task</label>
            <input
              readonly
              v-model="bodyEditActivities.task"
              type="text"
              class="form-control"
              placeholder="Task" />
          </div>

          <div class="col-6 mt-4">
            <p class="form-label">Start Date</p>
            <input
              readonly
              type="date"
              class="form-control"
              placeholder="Pilih Tanggal"
              v-model="bodyEditActivities.startDate" />
          </div>

          <div class="col-6 mt-4">
            <p class="form-label">End Date</p>
            <input
              readonly
              type="date"
              class="form-control"
              placeholder="Pilih Tanggal"
              v-model="bodyEditActivities.endDate" />
          </div>
          <div class="col-12 mt-4">
            <label>Percentage (%)</label>
            <input
              readonly
              v-model="bodyEditActivities.percentage"
              type="number"
              class="form-control"
              placeholder="Percentage" />
          </div>
          <!-- <div class="col-12 mt-4">
            <label class="form-label">Status</label>
            <v-select
              v-model="bodyEditActivities.status"
              :options="statusActivities"
              label="name"
              :reduce="(e) => e.id"
              placeholder="Select Status"></v-select>
          </div> -->
          <div v-if="this.projectStatus != 'submitted'" class="col-12 mt-4">
            <p class="form-label">Actual Start Date</p>
            <input
              readonly
              type="date"
              class="form-control"
              placeholder="Pilih Tanggal"
              v-model="bodyEditActivities.actualStartDate" />
          </div>
          <!-- <div class="col-2 mt-4">
            <b-button class="mt-4" @click="setActualStartDate" variant="primary"
              >Start</b-button
            >
          </div> -->
          <div v-if="this.projectStatus !== 'draft'" class="col-12 mt-4">
            <h4>
              Progress Data
              <!-- <b-button
                  v-if="this.progressPercentage != 100"
                  class="my-2 float-end"
                  @click="showAddProgress"
                  variant="primary"
                  ><span class="fe fe-plus"></span>Add Progress</b-button
                > -->
            </h4>

            <table class="table table-sm table-bordered">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Date</th>
                  <th>Progress (%)</th>
                </tr>
              </thead>
              <tbody v-if="milestone.length != 0">
                <tr v-for="(item, index) in milestone" :key="index">
                  <td>{{ item.name }}</td>
                  <td>{{ formatDateTable(item.date) }}</td>
                  <td>{{ item.progress }}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td class="text-center" colspan="12">No Data Available</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="this.projectStatus != 'submitted'" class="col-12 mt-4">
            <label class="form-label">Progress</label>
            <input
              type="range"
              min="0"
              max="100"
              step="1"
              v-model="progressPercentage"
              class="form-control-range mt-2"
              @mousedown.prevent
              @touchstart.prevent />
            <p class="mt-2">{{ progressPercentage }}%</p>
          </div>

          <div v-if="progressPercentage == 100" class="col-12 mt-4">
            <p class="form-label">Actual End Date</p>
            <input
              readonly
              type="date"
              class="form-control"
              placeholder="Pilih Tanggal"
              v-model="bodyEditActivities.actualEndDate" />
          </div>
          <!-- <div v-if="progressPercentage == 100" class="col-2 mt-4">
            <b-button class="mt-4" @click="setActualEndDate" variant="primary"
              >Finish</b-button
            >
          </div> -->
          <div v-if="progressPercentage == 100" class="col-12 mt-4">
            <label>Feedback</label>
            <textarea
              v-model="bodyFeedback.feedback"
              type="text"
              class="form-control"
              placeholder="Feedback" />
          </div>
          <!-- <div v-if="progressPercentage == 100" class="col-12 mt-4">
            <label class="form-label">Attachment</label>
            <input
              type="file"
              @change="handleFileChange"
              class="form-control"
              accept=".jpg,.jpeg,.png" />
          </div> -->
        </div>
        <div v-if="this.projectStatus == 'in progress'" class="mt-4">
          <b-button
            class="float-end"
            @click="submitFeedback()"
            variant="primary"
            >Update</b-button
          >
        </div>
      </div>
    </b-modal>
    <!-- Modal Schedule -->
    <b-modal
      v-model="isScheduleModalVisible"
      title="Add Schedule"
      size="xl"
      hide-footer
      @hide="clearScheduleModal">
      <div class="form-group">
        <div class="row">
          <div class="col-6">
            <p class="form-label">Date</p>
            <v-date-picker
              style="width: 350px"
              v-model="schedule.date"
              type="date"
              format="DD-MM-YYYY"
              placeholder="Select Date" />
          </div>
          <div class="col-6">
            <p class="form-label">Start Time</p>
            <v-date-picker
              style="width: 350px"
              v-model="schedule.startTime"
              type="time"
              format="HH:mm"
              placeholder="Select Start Time" />
          </div>
          <div class="col-6 mt-4">
            <p class="form-label">End Time</p>
            <v-date-picker
              style="width: 350px"
              v-model="schedule.endTime"
              type="time"
              format="HH:mm"
              placeholder="Select End Time" />
          </div>
        </div>
        <div class="mt-4">
          <b-button
            class="float-end my-3"
            @click="addSchedule"
            variant="primary"
            >Add</b-button
          >
        </div>
        <h4>The schedule will be added:</h4>
        <table class="table table-sm table-bordered">
          <thead>
            <tr>
              <th>Date</th>
              <th>Start Time</th>
              <th>End Time</th>
              <th style="width: 50px">Action</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="scheduleList.length === 0">
              <tr>
                <td class="text-center" colspan="4">No Data Available</td>
              </tr>
            </template>
            <template v-else>
              <tr v-for="(item, index) in scheduleList" :key="index">
                <td>{{ item.date }}</td>
                <td>{{ item.startTime }}</td>
                <td>{{ item.endTime }}</td>
                <td>
                  <button
                    @click="removeSchedule(index)"
                    class="btn btn-sm btn-danger">
                    <span class="fe fe-trash"></span>
                  </button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
        <div class="mt-4">
          <b-button class="float-end" @click="saveSchedule" variant="primary"
            ><span class="fe fe-save"></span>Save</b-button
          >
        </div>
      </div>
    </b-modal>
    <!-- Modal Add Training -->
    <b-modal
      ref="modalTrainingAspiration"
      id="modal-training-aspiration"
      title="Buat Pelatihan Aspiration"
      hide-footer
      size="xl"
      centered>
      <div class="form-group">
        <div class="row">
          <!-- Bagian 1 -->
          <div class="col-12">
            <label class="form-label">Employee</label>
            <v-select
              v-model="bodyAdd.nik"
              :options="dataEmployee"
              label="employee_name"
              :reduce="(e) => e.employee_nik"
              placeholder="Select Employee" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label"
              >Competency
              <span class="text-danger"
                >(* Proficiency level is below standard)</span
              ></label
            >
            <v-select
              v-model="bodyAdd.competency"
              :options="dataCompetency"
              label="competency"
              :reduce="(e) => e.competency_id"
              placeholder="Select Competency" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Provider</label>
            <v-select
              v-model="bodyAdd.provider"
              :options="dataProvider"
              label="name"
              @input="selectProvider"
              :reduce="(e) => e.id"
              placeholder="Select Provider" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Provider Name</label>
            <input
              v-model="bodyAdd.providerName"
              type="text"
              class="form-control"
              placeholder="Provider Name" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Address</label>
            <input
              type="text"
              v-model="bodyAdd.address"
              class="form-control"
              placeholder="Address" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Website</label>
            <input
              type="text"
              v-model="bodyAdd.websiteProvider"
              class="form-control"
              placeholder="Website" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Contact Person</label>
            <input
              type="text"
              v-model="bodyAdd.contactPerson"
              class="form-control"
              placeholder="Contact Person" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Email</label>
            <input
              type="text"
              v-model="bodyAdd.email"
              class="form-control"
              placeholder="Email" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Phone</label>
            <input
              type="number"
              class="form-control"
              v-model="bodyAdd.phone"
              placeholder="Phone" />
          </div>

          <!-- Bagian 2 -->
          <div class="col-6 mt-4">
            <label for=""
              >Training
              <span class="text-danger">(* Search Training If Exist)</span>
            </label>
            <v-select
              v-model="selectedLearning"
              :options="dataTraining"
              label="title"
              @input="selectTraining"
              @search="searchTraining"
              placeholder="Search Training">
              <!-- <span slot="no-options">Search Learning Title</span> -->
            </v-select>
          </div>
          <div class="col-6 mt-4">
            <label class="form-label">Training Name</label>
            <input
              type="text"
              class="form-control"
              v-model="bodyAdd.trainingName"
              placeholder="Training Name" />
          </div>
          <div class="col-6 mt-4">
            <label class="form-label">Training Method</label>
            <v-select
              v-model="bodyAdd.learningMethod"
              :options="dataTrainingMethod"
              label="name"
              :reduce="(e) => e.id"
              placeholder="Select Training Method" />
          </div>
          <div class="col-6 mt-4">
            <label class="form-label">Training Type</label>
            <v-select
              v-model="bodyAdd.learningType"
              :options="dataTrainingType"
              label="name"
              :reduce="(e) => e.id"
              placeholder="Select Training Type" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Price</label>
            <div class="d-flex">
              <v-select
                style="width: 140px; color: gray"
                :options="currencies"
                v-model="bodyAdd.currency"
                class="mr-2" />
              <input
                v-model="bodyAdd.price"
                type="number"
                class="form-control"
                placeholder="Input Price (Numeric)" />
            </div>
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Website</label>
            <input
              type="text"
              class="form-control"
              v-model="bodyAdd.websiteTraining"
              placeholder="Website" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Hours</label>
            <input
              v-model="bodyAdd.hours"
              type="number"
              class="form-control"
              placeholder="Input Hours" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Description</label>
            <textarea
              v-model="bodyAdd.description"
              type="text"
              class="form-control"
              placeholder="Input Description" />
          </div>
          <!-- <div class="col-12 mt-4">
            <label class="form-label">Schedule</label>
          </div>
          <div class="col-6">
            <p class="form-label">Start Date</p>
            <v-date-picker style="width: 530px" />
          </div>
          <div class="col-6">
            <p class="form-label">End Date</p>
            <v-date-picker style="width: 530px" />
          </div> -->
        </div>
      </div>
      <b-button class="float-end" variant="primary" @click="createTraining()"
        >Submit
      </b-button>
    </b-modal>
    <!-- Modal Score Structured -->
    <b-modal
      v-model="isModalScoreStructured"
      title="Add Score"
      size="lg"
      hide-footer>
      <div class="form-group">
        <div class="row">
          <div class="col-12">
            <label>Score</label>
            <input
              v-model="bodyScoreStructured.score"
              type="text"
              class="form-control"
              placeholder="Score" />
          </div>
          <div class="col-12 mt-4">
            <label>Feedback</label>
            <input
              v-model="bodyScoreStructured.feedback"
              type="text"
              class="form-control"
              placeholder="Feedback" />
          </div>
        </div>
      </div>
      <b-button
        class="float-end"
        variant="primary"
        @click="submitScoreStructured()"
        >Submit
      </b-button>
    </b-modal>
    <!-- Modal Score Social -->
    <b-modal
      v-model="isModalScoreSocial"
      title="Add Score"
      size="lg"
      hide-footer>
      <div class="form-group">
        <div class="row">
          <div class="col-12">
            <label>Score</label>
            <input
              v-model="bodyScoreSocial.score"
              type="text"
              class="form-control"
              placeholder="Score" />
          </div>
          <div class="col-12 mt-4">
            <label>Feedback</label>
            <input
              v-model="bodyScoreSocial.feedback"
              type="text"
              class="form-control"
              placeholder="Feedback" />
          </div>
        </div>
      </div>
      <b-button class="float-end" variant="primary" @click="submitScoreSocial()"
        >Submit
      </b-button>
    </b-modal>
    <b-modal
      v-model="isModalAssign"
      title="Assign Project"
      size="xl"
      hide-footer>
      <div v-if="isLoading" class="text-center my-4">
        <span class="spinner-border" role="status" aria-hidden="true"></span>
        <span>Loading...</span>
      </div>
      <table v-else class="table table-sm table-bordered table-nowrap mt-4">
        <!-- {{
          projectData
        }} -->
        <thead>
          <tr class="">
            <th rowspan="2">Project Name</th>
            <th rowspan="2">Related Competencies</th>
            <th rowspan="2">Duration</th>
            <th rowspan="2">Start Date</th>
            <th rowspan="2">End Date</th>
            <th rowspan="2">Role</th>
            <th rowspan="2">Requirement</th>
            <th rowspan="2">Assignee</th>
            <th rowspan="2"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in projectData" :key="index">
            <td class="fw-bold">
              {{ item.project_name }}
            </td>
            <td>
              <ul class="list-unstyled mb-0">
                <li
                  v-for="(competency, cIndex) in item.competencies"
                  :key="cIndex">
                  {{ competency.competency }}
                </li>
              </ul>
            </td>
            <td class="">
              {{ item.project_duration }}
            </td>
            <td class="">
              {{ formatDateTable(item.project_start_date) }}
            </td>
            <td class="">
              {{ formatDateTable(item.project_end_date) }}
            </td>
            <td>
              <ul class="list-unstyled mb-0">
                <li v-for="(role, rIndex) in item.roles" :key="rIndex">
                  {{ role.project_role_name }}
                </li>
              </ul>
            </td>
            <td>
              <ul class="list-unstyled mb-0">
                <li v-for="(role, rIndex) in item.roles" :key="rIndex">
                  {{ role.project_role_quantity }}
                </li>
              </ul>
            </td>
            <td>
              <ul class="list-unstyled mb-0">
                <li v-for="(role, rIndex) in item.roles" :key="rIndex">
                  <ul class="pl-3">
                    <li
                      v-for="(assignee, aIndex) in role.assignee"
                      :key="aIndex">
                      {{ assignee.employee_name }}
                    </li>
                  </ul>
                </li>
              </ul>
            </td>
            <td class="">
              <ul class="list-unstyled mb-0">
                <li v-for="(role, rIndex) in item.roles" :key="rIndex">
                  <input
                    type="checkbox"
                    v-model="
                      checkedRoles[
                        item.project_id + '-' + role.project_role_name
                      ]
                    "
                    :value="role.project_role_name" />
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>

      <b-button class="float-end" variant="primary" @click="submitAssignee()"
        >Assign
      </b-button>
    </b-modal>
    <!-- Modal Activity -->
    <b-modal
      v-model="isModalActivities"
      title="Project Activity"
      size="xl"
      hide-footer
      @hide="clearBodyActivities">
      <!-- {{selectedRow}} -->
      <b-card>
        <b-card-body>
          <b-row>
            <b-col md="3">
              <b-card-title>Project Name</b-card-title>
              <b-card-text v-if="selectedRow">{{
                selectedRow.name
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3">
              <b-card-title>Project Description</b-card-title>
              <b-card-text v-if="selectedRow">{{
                selectedRow.description
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3">
              <b-card-title>Duration</b-card-title>
              <b-card-text v-if="selectedRow"
                >{{ selectedRow.duration }} Days</b-card-text
              >
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="">
              <b-card-title>Status</b-card-title>
              <b-card-text v-if="selectedRow">
                <h2>
                  <span :class="getBadgeStatus(selectedRow.status)">
                    <i
                      :class="getIconClass(selectedRow.status)"
                      class="me-1"></i>
                    {{ capitalizeStatus(selectedRow.status) }}</span
                  >
                </h2>
              </b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3" class="mt-4">
              <b-card-title>Start Date</b-card-title>
              <b-card-text v-if="selectedRow">{{
                formatDateTable(selectedRow.start_date)
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>End Date</b-card-title>
              <b-card-text v-if="selectedRow">{{
                formatDateTable(selectedRow.end_date)
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Involvement</b-card-title>
              <b-card-text v-if="selectedRow">{{
                selectedRow.involment
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Project Team</b-card-title>
              <b-card-text v-if="selectedRow">{{
                selectedRow.subordinate
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3" class="mt-4">
              <b-card-title>Bussiness Need</b-card-title>
              <b-card-text v-if="selectedRow">{{
                selectedRow.business_need
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Objectives</b-card-title>
              <b-card-text v-if="selectedRow">{{
                selectedRow.objectives
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Goals</b-card-title>
              <b-card-text v-if="selectedRow">{{
                selectedRow.goals
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Scope</b-card-title>
              <b-card-text v-if="selectedRow">{{
                selectedRow.scope
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3" class="mt-4">
              <b-card-title>Constraints</b-card-title>
              <b-card-text v-if="selectedRow">{{
                selectedRow.constraints
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Deliverables</b-card-title>
              <b-card-text v-if="selectedRow">{{
                selectedRow.deliverables
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Impact A</b-card-title>
              <b-card-text v-if="selectedRow">{{
                selectedRow.impact_a
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Impact</b-card-title>
              <b-card-text v-if="selectedRow">{{
                selectedRow.impact
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4" class="mt-4">
              <b-card-title>Impact B</b-card-title>
              <b-card-text v-if="selectedRow">{{
                selectedRow.impact_b
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row>
          <b-row>
            <b-col v-if="selectedRow">
              <b-card-title>Attachment</b-card-title>
              <img
                :src="
                  selectedRow.attachments[0]
                    ? selectedRow.attachments[0].url
                    : ''
                "
                :style="{ width: '300px', height: 'auto' }"
                alt="Certificate"
                class="img-fluid" />
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
      <!-- <div class="mt-4 float-end mb-4">
        <b-button @click="addActivities" variant="primary"
          ><span class="fe fe-plus"></span>Add Activities</b-button
        >
      </div> -->

      <!-- Activities Table -->
      <div class="mt-4">
        <h4>Activities</h4>
        <table class="table table-sm table-bordered">
          <thead>
            <tr>
              <!-- <th>ID</th> -->
              <th>Task</th>
              <th>Start Date</th>
              <th>End Date</th>
              <!-- <th>Predecessor</th> -->
              <th>Actual Start Date</th>
              <th>Actual End Date</th>
              <th>Progress (%)</th>
              <th>Percentage (%)</th>
              <th>Status</th>
              <th>Evidence File</th>
              <th>Feedback</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody v-if="dataActivities.length != 0">
            <tr v-for="(item, index) in dataActivities" :key="index">
              <!-- <td>{{ item.iel_id }}</td> -->
              <td>{{ item.task }}</td>
              <td>{{ formatDateTable(item.start_date) }}</td>
              <td>{{ formatDateTable(item.end_date) }}</td>
              <!-- <td>{{ item.predecessor || "-" }}</td> -->
              <td>{{ formatDateTable(item.actual_start_date) || "-" }}</td>
              <td>{{ formatDateTable(item.actual_end_date) || "-" }}</td>
              <td>{{ item.new_progress || "-" }}</td>
              <td>{{ item.percentage || "-" }}</td>
              <td class="text-center">
                <h3>
                  <span :class="getBadgeStatus(item.status)">
                    <i :class="getIconClass(item.status)" class="me-1"></i>
                    {{ capitalizeStatus(item.status) }}
                  </span>
                </h3>
              </td>
              <td>
                <a
                  v-if="item.evidence && item.evidence.length > 0"
                  :href="item.evidence[0].url"
                  target="_blank">
                  Files
                </a>
                <span v-else>-</span>
              </td>
              <td>
                <ul>
                  <li v-for="(feedback, fIndex) in item.feedback" :key="fIndex">
                    {{ feedback.feedback }}
                  </li>
                </ul>
              </td>
              <td class="text-center">
                <!-- <button
                  v-if="item.status !== 'to do'"
                  class="btn btn-sm btn-info mx-1 my-1"
                  @click="addFeedback(item)"
                  v-b-tooltip.hover="'Add Feedback'">
                  <span class="fe fe-message-square"></span>
                </button> -->
                <button
                  v-if="item.status != 'completed'"
                  class="btn btn-sm btn-info mx-1 my-1"
                  @click="editActivities(item)"
                  v-b-tooltip.hover="'Detail'">
                  <span class="fe fe-eye"></span>
                </button>
                <button
                  v-if="
                    !(
                      selectedRow.status == 'submitted' &&
                      aboutMe.roles == 'Manager'
                    ) && item.status != 'completed'
                  "
                  class="btn btn-sm btn-danger mx-1 my-1"
                  @click="deleteActivities(item)"
                  v-b-tooltip.hover="'Delete'">
                  <span class="fe fe-trash"></span>
                </button>
                <!-- <button
                  v-if="item.status === 'in review'"
                  class="btn btn-sm btn-success mx-1 my-1"
                  @click="completeActivities(item)"
                  v-b-tooltip.hover="'Complete Activities'">
                  <span class="fe fe-check-circle"></span>
                </button> -->
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td class="text-center" colspan="12">No Data Available</td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
    <!-- Modal Approval -->
    <b-modal
      v-model="isModalApproval"
      title="Approval Form"
      size="lg"
      hide-footer>
      <div class="form-group">
        <div class="row">
          <div class="col-12 mt-4">
            <label>Notes</label>
            <input
              v-model="bodyApproval.notes"
              type="text"
              class="form-control"
              placeholder="Notes" />
          </div>
          <div class="col-12 mt-4">
            <label>Approval Status</label>
            <b-form-group>
              <b-form-radio-group v-model="bodyApproval.status">
                <b-form-radio value="approved">Approved</b-form-radio>
                <b-form-radio value="revision">Need Revision</b-form-radio>
                <b-form-radio value="rejected">Rejected</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>
        </div>
      </div>
      <b-button class="float-end" variant="primary" @click="submitApproval()"
        >Submit
      </b-button>
    </b-modal>
    <!-- Feedback Social -->
    <b-modal
      v-model="isFeedbackSocial"
      title="Add Feedback"
      size="lg"
      hide-footer>
      <div class="form-group">
        <div class="row">
          <div class="col-12 mt-4">
            <label class="form-label"
              >Summary <span class="text-danger ml-2">*Read only</span></label
            >
            <textarea
              readonly
              v-model="bodyFeedback.summary"
              type="text"
              class="form-control"
              placeholder="Summary" />
          </div>

          <div class="col-12 mt-4">
            <p class="form-label">
              Follow up <span class="text-danger ml-2">*Read only</span>
            </p>
            <textarea
              readonly
              type="text"
              class="form-control"
              placeholder="Follow up"
              v-model="bodyFeedback.follow_up" />
          </div>
          <div class="col-12 mt-4">
            <label>Feedback</label>
            <textarea
              v-model="bodyFeedback.feedback"
              type="text"
              class="form-control"
              placeholder="Feedback" />
          </div>
          <!-- <div class="col-12 mt-4">
            <label class="form-label">Attachment</label>
            <input
              type="file"
              @change="handleFileChange"
              class="form-control"
              accept=".jpg,.jpeg,.png" />
          </div> -->
        </div>
      </div>
      <b-button
        class="float-end"
        variant="primary"
        @click="submitFeedbackSocial()"
        >Submit
      </b-button>
    </b-modal>
    <!-- Feedback Social Completed -->
    <b-modal
      v-model="feedbackCompleted"
      title="View Result"
      size="lg"
      hide-footer>
      <div class="form-group">
        <div class="row">
          <div class="col-12 mt-4">
            <label class="form-label">Summary </label>
            <textarea
              readonly
              v-model="bodyFeedback.summary"
              type="text"
              class="form-control"
              placeholder="Summary" />
          </div>

          <div class="col-12 mt-4">
            <p class="form-label">Follow up</p>
            <textarea
              readonly
              type="text"
              class="form-control"
              placeholder="Follow up"
              v-model="bodyFeedback.follow_up" />
          </div>
          <div class="col-12 mt-4">
            <label>Feedback</label>
            <textarea
              readonly
              v-model="bodyFeedback.feedback"
              type="text"
              class="form-control"
              placeholder="Feedback" />
          </div>
          <!-- <div class="col-12 mt-4">
            <label class="form-label">Attachment</label>
            <input
              type="file"
              @change="handleFileChange"
              class="form-control"
              accept=".jpg,.jpeg,.png" />
          </div> -->
        </div>
      </div>
      <!-- <b-button
        class="float-end"
        variant="primary"
        @click="submitFeedbackSocial()"
        >Submit
      </b-button> -->
    </b-modal>
    <!-- Modal Feedback Activities -->
    <b-modal
      v-model="isModalFeedbackActivities"
      title="Add Feedback"
      size="lg"
      hide-footer>
      <div class="form-group">
        <div class="row">
          <div class="col-12 mt-4">
            <label>Feedback</label>
            <textarea
              v-model="bodyFeedback.feedback"
              type="text"
              class="form-control"
              placeholder="Feedback" />
          </div>
        </div>
      </div>
      <b-button class="float-end" variant="primary" @click="submitFeedback()"
        >Submit
      </b-button>
    </b-modal>
    <!-- View Feedback -->
     <b-modal
      v-model="isModalViewFeedback"
      title="Current Competency Proficiency after IDP"
      size="lg"
      hide-footer>
      <div class="form-group">
        <div class="row">
          <!-- Kompetensi -->
          <div class="row justify-content-center mb-4">
            <div class="col-12">
              <table class="table table-bordered text-center">
                <thead class="table-light">
                  <tr>
                    <th>Competency</th>
                    <th>Old Proficiency</th>
                    <th>Standart Proficiency</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ bodyProficiencyView.competency }}</td>
                    <td>{{ bodyProficiencyView.old_proficiency }}</td>
                    <td>{{ bodyProficiencyView.standartd_proficiency }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Proficiency Saat Ini -->
          <div class="col-md-6 col-12 mb-3">
            <label class="form-label">New Proficiency</label>
            <input
              v-model="bodyProficiencyView.proficiency"
              type="number"
              class="form-control"
              placeholder="Nilai Saat Ini" disabled />
          </div>

          <!-- Feedback (textarea) -->
          <div class="col-md-6 col-12 mb-3">
            <label class="form-label">Feedback</label>
            <textarea
              v-model="bodyProficiencyView.feedback"
              class="form-control"
              rows="4"
              placeholder="Tulis feedback lebih lengkap..." disabled></textarea>
          </div>
        </div>
      </div>
      <!-- <b-button class="float-end" variant="primary" @click="submitFeedback()"
        >Submit
      </b-button> -->
    </b-modal>
    <!-- Modal Project User -->
    <b-modal
      v-model="isModalFeedback"
      title="Project User"
      size="xl"
      hide-footer>
      <div v-if="isLoading" class="text-center my-4">
        <span class="spinner-border" role="status" aria-hidden="true"></span>
        <span>Loading...</span>
      </div>
      <div class="table-responsive">
        <table class="table table-sm table-bordered table-nowrap mt-4">
          <thead>
            <tr class="">
              <th rowspan="2">Project ID</th>
              <th rowspan="2">Competency</th>
              <th rowspan="2">Project Name</th>
              <th rowspan="2">Project Type</th>
              <th rowspan="2">Start Date</th>
              <th rowspan="2">End Date</th>
              <th rowspan="2">Duration (Days)</th>
              <th rowspan="2">Status</th>
              <th rowspan="2">Action</th>
            </tr>
          </thead>
          <tbody v-if="projectUser.length > 0">
            <tr v-for="(item, index) in projectUser" :key="index">
              <td class="text-center">
                {{ item.project_id }}
              </td>
              <td class="">
                <ul class="list-unstyled mb-0">
                  <li
                    v-for="(competency, cIndex) in item.competencies"
                    :key="cIndex">
                    {{ competency.competency_name }}
                  </li>
                </ul>
              </td>
              <td class="text-center">
                {{ item.project_name }}
              </td>
              <td class="text-center">
                {{ item.project_type }}
              </td>
              <td class="text-center">
                {{ formatDateTable(item.project_start_date) || "-" }}
              </td>
              <td class="text-center">
                {{ formatDateTable(item.project_end_date) }}
              </td>
              <td class="text-center">
                {{ item.project_duration }}
              </td>
              <td class="text-center">
                <h2>
                  <span :class="getBadgeStatus(item.status)">
                    <i :class="getIconClass(item.status)" class="me-1"></i>
                    {{ capitalizeStatus(item.status) }}</span
                  >
                </h2>
              </td>

              <td class="text-center">
                <button
                  @click="viewActivities(item)"
                  v-if="item.status === 'submitted'"
                  class="btn btn-sm btn-primary mx-2">
                  <span class="fe fe-file-text"></span>
                </button>
                <!-- <button
                          v-if="item.status === 'Execution'"
                          class="btn btn-sm btn-warning mx-2">
                          <span class="fe fe-edit"></span>
                        </button> -->
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td class="text-center" colspan="12">No Data Available</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- <b-button class="float-end" variant="primary" @click="submitAssignee()"
        >Assign
      </b-button> -->
    </b-modal>

    <!-- Modal Detail Structured -->
    <b-modal
      v-model="isModalStructured"
      title="Detail View"
      size="xl"
      @hide="clearSelectedRow">
      <b-card>
        <b-card-body>
          <b-row>
            <!-- <b-col md="3">
              <b-card-title>Competency</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{
                selectedRowStructured.competency
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col> -->
            <b-col md="3">
              <b-card-title>Training Title</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{
                selectedRowStructured.training_title
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3">
              <b-card-title>Training Type</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{
                selectedRowStructured.training_type
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3">
              <b-card-title>Training Method</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{
                selectedRowStructured.training_method
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="">
              <b-card-title>Status</b-card-title>
              <b-card-text v-if="selectedRowStructured">
                <h2>
                  <span :class="getBadgeStatus(selectedRowStructured.status)">
                    <i
                      :class="getIconClass(selectedRowStructured.status)"
                      class="me-1"></i>
                    {{ capitalizeStatus(selectedRowStructured.status) }}</span
                  >
                </h2>
              </b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row>
          <b-row>
            <!-- <b-col md="3" class="mt-4">
              <b-card-title>Score</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{
                selectedRowStructured.score || "-"
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col> -->
            <b-col md="3" class="mt-4">
              <b-card-title>Feedback</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{
                selectedRowStructured.feedback || "-"
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Training Provider</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{
                selectedRowStructured.training_provider
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Price</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{
                formatPrice(selectedRowStructured.price)
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row>
          <!-- <b-row>
            <b-col md="3" class="mt-4">
              <b-card-title>Status</b-card-title>
              <b-card-text v-if="selectedRowStructured">
                <h2>
                  <span
                    :class="
                      getBadgeStatus(selectedRowStructured.status)
                    ">
                    {{ capitalizeStatus(selectedRowStructured.status) }}</span
                  >
                </h2>
              </b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row> -->
          <b-row md="4" class="mt-4" v-if="selectedRowStructured">
            <b-col v-if="selectedRowStructured.certificate">
              <b-card-title>Certificate</b-card-title>
              <img
                :src="certificateUrl"
                :style="{ width: '300px', height: 'auto' }"
                alt="Certificate"
                class="img-fluid" />
              <!-- <b-button
                class="btn btn-primary"
                variant="primary"
                @click="downloadCertificate()">
                <span class="fe fe-download"></span>
                Download Certificate
              </b-button> -->
            </b-col>
          </b-row>
          <!-- <b-button
            variant="primary"
            class="float-end"
            @click="completeReview(item)">
            <span class="fe fe-check-circle"></span> Complete
          </b-button> -->
        </b-card-body>
      </b-card>
    </b-modal>
    <!-- Modal Detail Social -->
    <b-modal v-model="isModalSocial" title="Detail View" size="xl">
      <b-card>
        <b-card-body>
          <b-row>
            <b-col md="3">
              <b-card-title>Coaching Title</b-card-title>
              <b-card-text v-if="selectedRowSocial">{{
                selectedRowSocial.coaching_title
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3">
              <b-card-title>Coaching Methodology</b-card-title>
              <b-card-text v-if="selectedRowSocial">{{
                selectedRowSocial.coaching_methodology
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3">
              <b-card-title>Coach Name</b-card-title>
              <b-card-text v-if="selectedRowSocial">{{
                selectedRowSocial.coach_name
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>

            <b-col md="3" class="">
              <b-card-title>Status</b-card-title>
              <b-card-text v-if="selectedRowSocial">
                <h2>
                  <span :class="getBadgeStatus(selectedRowSocial.status)">
                    <i
                      :class="getIconClass(selectedRowSocial.status)"
                      class="me-1"></i>
                    {{ capitalizeStatus(selectedRowSocial.status) }}</span
                  >
                </h2>
              </b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>

            <b-col md="3">
              <b-card-title>Presentation Documentation</b-card-title>
              <b-link
                :href="
                  linkPresentation(selectedRowSocial.presentation_document_url)
                "
                class="card-link"
                v-if="selectedRowSocial"
                target="_blank"
                >{{ selectedRowSocial.presentation_document_url }}</b-link
              >
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row>

          <div class="mt-4">
            <div class="row">
              <div class="col">
                <h4>Schedule</h4>
              </div>
              <div class="col" v-if="selectedRowSocial">
                <b-button
                  v-if="selectedRowSocial.status == 'approved'"
                  class="float-end my-2"
                  @click="showScheduleModal"
                  variant="primary"
                  ><span class="fe fe-plus"></span>Add Schedule</b-button
                >
              </div>
            </div>
            <table class="table table-sm table-bordered">
              <thead>
                <tr>
                  <th style="width: 110px">Date</th>
                  <th style="width: 50px">Start Time</th>
                  <th style="width: 50px">End Time</th>
                  <th>Summary</th>
                  <!-- <th>Follow Up</th> -->
                  <th style="width: 50px">Attachments</th>
                  <!-- <th>Feedback</th> -->
                  <th style="width: 50px">Action</th>
                </tr>
              </thead>
              <tbody>
                <template v-if="scheduleSocial.length === 0">
                  <tr>
                    <td class="text-center" colspan="7">No Data Available</td>
                  </tr>
                </template>
                <template v-else>
                  <tr v-for="(item, index) in scheduleSocial" :key="index">
                    <td>{{ formatDateTable(item.date) }}</td>
                    <td>{{ formatTime(item.start_time) }}</td>
                    <td>{{ formatTime(item.end_time) }}</td>

                    <!-- Summaries -->
                    <td>
                      <ul>
                        <li
                          v-for="(feedback, feedbackIndex) in item.feedback"
                          :key="'summary-' + feedbackIndex">
                          {{ feedback.summary }}
                        </li>
                        <template v-if="item.feedback.length === 0">
                          <li>No summaries available</li>
                        </template>
                      </ul>
                    </td>

                    <!-- Follow Ups -->
                    <!-- <td>
                      <ul>
                        <li
                          v-for="(feedback, feedbackIndex) in item.feedback"
                          :key="'followup-' + feedbackIndex">
                          {{ feedback.follow_up }}
                        </li>
                        <template v-if="item.feedback.length === 0">
                          <li>No follow-ups available</li>
                        </template>
                      </ul>
                    </td> -->

                    <!-- Attachments -->
                    <td>
                      <ul>
                        <li
                          v-for="(feedback, feedbackIndex) in item.feedback"
                          :key="'attachment-' + feedbackIndex">
                          <a
                            v-for="(
                              attachment, attachmentIndex
                            ) in feedback.attachments"
                            :key="'attachment-file-' + attachmentIndex"
                            :href="attachment.url"
                            target="_blank">
                            Files
                          </a>
                        </li>
                        <template v-if="item.feedback.length === 0">
                          <li>No attachments available</li>
                        </template>
                      </ul>
                    </td>
                    <!-- <td>
                      <ul>
                        <li
                          v-for="(feedback, feedbackIndex) in item.feedback"
                          :key="'followup-' + feedbackIndex">
                          {{ feedback.feedback }}
                        </li>
                        <template v-if="item.feedback.length === 0">
                          <li>No Feedback available</li>
                        </template>
                      </ul>
                    </td> -->

                    <!-- Action Button -->
                    <td>
                      <button
                        v-if="
                          (selectedRowSocial.status === 'approved' ||
                            selectedRowSocial.status === 'in progress') &&
                          item.feedback.length > 0
                        "
                        class="btn btn-sm btn-warning"
                        @click="showModalFeedback(item)"
                        v-b-tooltip.hover="'Input Coaching Result'">
                        <span class="fe fe-edit"></span>
                      </button>
                      <button
                        v-if="
                          selectedRowSocial.status === 'completed' &&
                          item.feedback.length > 0
                        "
                        class="btn btn-sm btn-info my-2"
                        @click="completedFeedback(item)"
                        v-b-tooltip.hover="'View Coaching Result'">
                        <span class="fe fe-eye"></span>
                      </button>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <div v-if="selectedRowSocial">
            <b-button
              v-if="selectedRowSocial.status == 'in review'"
              class="float-end my-2"
              @click="completeLearning"
              variant="primary"
              >Complete Learning</b-button
            >
          </div>
        </b-card-body>
      </b-card>
    </b-modal>
    <!-- Modal Confirmation -->
    <b-modal
      centered
      ref="confirmationModalStructured"
      id="confirmation-modal"
      title="Approve Training"
      @ok="confirmSubmissionStructured">
      <div>
        <h5>Will be Approved:</h5>
        <ul v-if="approvedItems && approvedItems.length > 0">
          <li v-for="item in approvedItems" :key="item.id" class="text-success">
            {{ item.training_title }}
          </li>
        </ul>
        <p v-else>No items to be submitted.</p>
        <h5>Will be rejected:</h5>
        <ul v-if="rejectedItems && rejectedItems.length > 0">
          <li v-for="item in rejectedItems" :key="item.id" class="text-danger">
            {{ item.training_title }}
          </li>
        </ul>
        <p v-else>No items to be rejected.</p>
      </div>
    </b-modal>

    <!-- Modal Confirmation Social -->
    <b-modal
      centered
      ref="confirmationModalSocial"
      id="confirmation-modal"
      title="Approve Coaching/Mentoring"
      @ok="confirmSubmissionSocial">
      <div>
        <h5>Will be Approved:</h5>
        <ul v-if="approvedItemsSocial && approvedItemsSocial.length > 0">
          <li
            v-for="item in approvedItemsSocial"
            :key="item.id"
            class="text-success">
            {{ item.coaching_title }}
          </li>
        </ul>
        <p v-else>No items to be submitted.</p>
        <h5>Will be rejected:</h5>
        <ul v-if="rejectedItemsSocial && rejectedItemsSocial.length > 0">
          <li
            v-for="item in rejectedItemsSocial"
            :key="item.id"
            class="text-danger">
            {{ item.coaching_title }}
          </li>
        </ul>
        <p v-else>No items to be rejected.</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axiosIns from "@/api/axios";

import "../../assets/js/theme.bundle";
import "../../assets/js/vendor.bundle";

export default {
  name: "myTeamIdp",
  data() {
    return {
      bodySearch: {
        company: "",
        directorate: "",
        division: "",
        department: ""
      },
      roleLogin: localStorage.getItem("roles"),
      bodyFilter: {},
      listTabMenu: {},
      bussinessUnit: [],
      bussinessUnit2: [],
      bussinessUnit3: [],
      bussinessUnit4: [],
      dataEmployee: [],
      currentPage: 1,
      itemsPerPage: 10,
      itemsPerPageOptions: [5, 10, 20, 50],
      nik: "",
      nikManager: "",
      name: "",
      position: "",
      idpExamination: [],
      employee: "",
      listEmployee: [],
      listKaryawan: [],
      isEditProficiency: false,
      bodyProficiency: {
        id: "",
        proficiency: "",
        feedback: "",
        competency: "",
        old_proficiency: "",
        standartd_proficiency: "",
      },
      bodyProficiencyView: {
        id: "",
        proficiency: "",
        feedback: "",
        competency: "",
        old_proficiency: "",
        standartd_proficiency: "",
      },
      sRowStructured: [],
      sRowSocial: [],
      projectStatus: "",
      milestone: [],
      scheduleList: [],
      schedule: {
        date: null,
        startTime: null,
        endTime: null
      },
      feedbackCompleted: false,
      isFeedbackSocial: false,
      isScheduleModalVisible: false,
      idIdpSocial: "",
      scheduleSocial: [],
      statusActivities: [
        { id: "to do", name: "To Do" },
        { id: "in progress", name: "In Progress" },
        { id: "completed", name: "Completed" }
      ],
      bodyEditActivities: {
        id_learning: "",
        id: "",
        task: "",
        startDate: "",
        endDate: "",
        predecessor: "",
        actualStartDate: "",
        actualEndDate: "",
        progress: "",
        status: "",
        evidenceFile: ""
      },
      progressPercentage: "",
      certificateUrl: "",
      certificateName: "",
      dataActivities: [],
      bodyActivities: {
        id_learning: "",
        id: "",
        task: "",
        startDate: "",
        endDate: "",
        predecessor: "",
        actualStartDate: "",
        actualEndDate: "",
        progress: "",
        status: "",
        evidenceFile: ""
      },
      bodyEditActivities: {
        id_learning: "",
        id: "",
        task: "",
        startDate: "",
        endDate: "",
        predecessor: "",
        actualStartDate: "",
        actualEndDate: "",
        progress: "",
        status: "",
        evidenceFile: ""
      },
      projectUser: [],
      selectedLearning: null,
      projectData: [],
      checkedRoles: {},
      certificateName: "",
      bodyScoreStructured: {
        id: "",
        score: "",
        feedback: ""
      },
      bodyScoreSocial: {
        id: "",
        score: "",
        feedback: ""
      },
      bodyFeedback: {
        id: "",
        nik: "",
        summary: "",
        follow_up: "",
        feedback: "",
        viewFeedback:""
      },
      bodyApproval: {
        id: "",
        notes: "",
        status: ""
      },
      bodyAdd: {
        nik: "",
        coaching: "",
        competency: "",
        provider: "",
        providerName: "",
        address: "",
        websiteProvider: "",
        contactPerson: "",
        email: "",
        phone: "",
        training: "",
        trainingName: "",
        learningMethod: "",
        learningType: "",
        currency: "IDR",
        price: "",
        websiteTraining: "",
        description: "",
        hours: ""
      },
      bodyAssign: {
        nik: ""
      },
      isModalStructured: false,
      isModalSocial: false,
      isModalScoreStructured: false,
      isModalScoreSocial: false,
      isModalAssign: false,
      isModalFeedback: false,
      isModalFeedbackActivities: false,
      isModalViewFeedback: false,
      isModalActivities: false,
      isModalApproval: false,
      isEditActivities: false,
      dataCompetency: [],
      listDatainReview: [],
      dataProvider: [],
      dataTrainingMethod: [],
      dataTrainingType: [],
      dataTraining: [],
      structuredLearning: [],
      socialLearning: [],
      experientialLearning: [],
      selectedRowStructured: null,
      selectedRowSocial: null,
      selectedRow: null,
      srStructuredLearning: [],
      srSocialLearning: [],
      srExperientialLearning: [],
      approvedItems: [],
      rejectedItems: [],
      approvedItemsSocial: [],
      rejectedItemsSocial: [],
      currencies: ["USD", "IDR"],
      selectedCurrency: "IDR",
      isLoading: true,
      isLoadingFilter: false,

      isEmpty: false,
      currentTab: 0,
      tabTitles: [
        "Progress Summary",
        "Structured Learning",
        "Social Learning",
        "Experiential Learning"
      ],
      summary: [
        {
          no: "A",
          isBold: true,
          isBab: true,
          isSub: false,
          isBehaviour: false,
          competency: "Managerial Competency",
          structureLearning: null,
          socialLearning: null,
          experientialLearning: null,
          status: null
        },
        {
          no: 1,
          isBold: true,
          isBab: false,
          isSub: true,
          isBehaviour: false,
          competency: "Personal Effectiveness",
          structureLearning: null,
          socialLearning: null,
          experientialLearning: null,
          status: null
        },
        {
          no: null,
          isBold: false,
          isBab: false,
          isSub: true,
          isBehaviour: false,
          competency: "Continuous Learning",
          structureLearning: "100%",
          socialLearning: "100%",
          experientialLearning: "100%",
          status: "Completed"
        },
        // {
        //   no: null,
        //   isBold: true,
        //   isBab: false,
        //   isSub: true,
        //   isBehaviour: true,
        //   competency: "Key Behaviour 1",
        //   structureLearning: "100%",
        //   socialLearning: "100%",
        //   experientialLearning: "100%",
        //   status: "Completed"
        // },
        // {
        //   no: null,
        //   isBold: true,
        //   isBab: false,
        //   isSub: true,
        //   isBehaviour: true,
        //   competency: "Key Behaviour 2",
        //   structureLearning: "100%",
        //   socialLearning: "100%",
        //   experientialLearning: "100%",
        //   status: "Completed"
        // },
        {
          no: "B",
          isBold: true,
          isBab: true,
          isSub: false,
          isBehaviour: false,
          competency: "Technical Competency",
          structureLearning: null,
          socialLearning: null,
          experientialLearning: null,
          status: null
        },
        {
          no: 1,
          isBold: true,
          isBab: false,
          isSub: true,
          isBehaviour: false,
          competency: "General Technical Management Competencies",
          structureLearning: null,
          socialLearning: null,
          experientialLearning: null,
          status: null
        },
        {
          no: null,
          isBold: false,
          isBab: false,
          isSub: true,
          isBehaviour: false,
          competency: "Risk Management",
          structureLearning: "100%",
          socialLearning: "100%",
          experientialLearning: "100%",
          status: "Completed"
        },
        // {
        //   no: null,
        //   isBold: true,
        //   isBab: false,
        //   isSub: true,
        //   isBehaviour: true,
        //   competency: "Key Behaviour 1",
        //   structureLearning: "100%",
        //   socialLearning: "100%",
        //   experientialLearning: "100%",
        //   status: "Completed"
        // },
        {
          no: 2,
          isBold: true,
          isBab: false,
          isSub: true,
          isBehaviour: false,
          competency: "Core Technical Competencies",
          structureLearning: null,
          socialLearning: null,
          experientialLearning: null,
          status: null
        },
        {
          no: null,
          isBold: false,
          isBab: false,
          isSub: true,
          isBehaviour: false,
          competency: "Bussiness Savvy",
          structureLearning: "0%",
          socialLearning: "0%",
          experientialLearning: "0%",
          status: "In Progress"
        }
      ]
    };
  },
  computed: {
    totalPages() {
      return this.idpExamination && this.idpExamination.all
        ? Math.ceil(this.idpExamination.all.length / this.itemsPerPage)
        : 0;
    },
    paginatedItems() {
      if (this.idpExamination && this.idpExamination.all) {
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        return this.idpExamination.all.slice(start, end);
      }
      return [];
    },
    aboutMe() {
      return this.$store.getters["users/profiles"];
    },
    flattenedProjectData() {
      let flattened = [];

      this.projectData.forEach((project) => {
        project.roles.forEach((role) => {
          flattened.push({
            project_name: project.project_name,
            competencies: project.competencies,
            project_duration: project.project_duration,
            project_start_date: project.project_start_date,
            project_end_date: project.project_end_date,
            role_name: role.project_role_name,
            role_quantity: role.project_role_quantity,
            assignees: role.assignee,
            project_id: project.project_id,
            role_id: role.project_role_id
          });
        });
      });

      return flattened;
    },
    allRoles() {
      let roles = [];
      this.projectData.forEach((project) => {
        project.roles.forEach((role) => {
          if (!roles.includes(role.project_role_name)) {
            roles.push(role.project_role_name);
          }
        });
      });
      return roles;
    },
    activeTabTitle() {
      return this.tabTitles[this.currentTab];
    },
    aboutMe() {
      return this.$store.getters["users/profiles"];
    }
  },
  watch: {
    aboutMe() {
      this.getEmployee();
    },
    selectedLearning(newVal) {
      if (newVal) {
        this.bodyAdd.training = newVal.id;
      } else {
        this.bodyAdd.training = null;
      }
    },
    "bodyAdd.provider": "fetchTrainingData",
    "bodyAdd.competency": "fetchCoaching"
  },
  methods: {
    getBusinessUnit() {
      this.$store.dispatch("business/getBusinessUnit").then((res) => {
        this.bussinessUnit = res.data.data;
      });
    },
    onBussinessUnitSelected(now) {
      if (now == "company") {
        if (!this.bodySearch.company) {
          (this.bodySearch.department = ""),
            (this.bodySearch.directorate = ""),
            (this.bodySearch.division = "");
        } else {
          this.bodyFilter.type = "";
          this.bodyFilter.unit = this.bodySearch.company;
          let body = {
            type: "DIR",
            unit: this.bodySearch.company
          };
          let bodyEmployee = {
            type: "COM",
            unit: this.bodySearch.company
          };
          axiosIns
            .post(
              `${axiosIns.defaults.baseURL}/master-data/business-unit-new`,
              body
            )
            .then((resp) => {
              this.bussinessUnit2 = resp.data.data;
            });
          axiosIns
            .post(
              `${axiosIns.defaults.baseURL}/master-data/business-unit-new/employee`,
              bodyEmployee
            )
            .then((resp) => {
              this.listKaryawan = resp.data.data;
            });
        }
      } else if (now == "dir") {
        if (!this.bodySearch.directorate) {
          (this.bodySearch.department = ""), (this.bodySearch.division = "");
        } else {
          this.bodyFilter.type = "DIR";
          this.bodyFilter.unit = this.bodySearch.directorate;
          let body = {
            type: "DIV",
            unit: this.bodySearch.directorate
          };
          let bodyEmployee = {
            type: "DIR",
            unit: this.bodySearch.directorate
          };
          axiosIns
            .post(
              `${axiosIns.defaults.baseURL}/master-data/business-unit-new`,
              body
            )
            .then((resp) => {
              this.bussinessUnit3 = resp.data.data;
            });
          axiosIns
            .post(
              `${axiosIns.defaults.baseURL}/master-data/business-unit-new/employee`,
              bodyEmployee
            )
            .then((resp) => {
              this.listKaryawan = resp.data.data;
            });
        }
      } else if (now == "div") {
        if (!this.bodySearch.division) {
          this.bodySearch.department = "";
        } else {
          this.bodyFilter.type = "DIV";
          this.bodyFilter.unit = this.bodySearch.division;
          let body = {
            type: "DEP",
            unit: this.bodySearch.division
          };
          let bodyEmployee = {
            type: "DIV",
            unit: this.bodySearch.division
          };
          axiosIns
            .post(
              `${axiosIns.defaults.baseURL}/master-data/business-unit-new`,
              body
            )
            .then((resp) => {
              console.log(resp.data.data);

              this.bussinessUnit4 = resp.data.data;
            });
          axiosIns
            .post(
              `${axiosIns.defaults.baseURL}/master-data/business-unit-new/employee`,
              bodyEmployee
            )
            .then((resp) => {
              this.listKaryawan = resp.data.data;
            });
        }
      } else if (now == "dept") {
        this.bodyFilter.type = "DEP";
        this.bodyFilter.unit = this.bodySearch.department;
        let bodyEmployee = {
          type: "DEP",
          unit: this.bodySearch.department
        };
        axiosIns
          .post(
            `${axiosIns.defaults.baseURL}/master-data/business-unit-new/employee`,
            bodyEmployee
          )
          .then((resp) => {
            this.listKaryawan = resp.data.data;
          });
      }
      // this.bodySearch.businessUnit = selectedBusinessUnit;

      // this.getHrData();
    },
    getEmployees() {
      this.$store.dispatch("employee/getEmployees").then((response) => {
        // console.log("response",response.data)
        this.listKaryawan = response.data;
      });
    },
    bulkApproved() {
      this.$swal({
        title: "Apakah Anda yakin?",
        text: "Apakah Anda yakin menyetujui data yang berstatus review? ",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Ya",
        cancelButtonText: "Batal"
      }).then((result) => {
        if (result.isConfirmed) {
          const id = this.idpExamination.all.filter(item => item.status === 'Review').map(item => item.id)

          let datas = {
            // id: this.listDatainReview.map(item => item.id)
            id
          }
          if (datas.id.length === 0) {
            this.$swal("Error", "Tidak ada data untuk disetujui", "error");
          } else {
            this.$store.dispatch("myIdp/bulkApprovedLND", datas)
              .then((response) => {
                this.$swal(
                  "Selesai",
                  "Persetujuan berhasil",
                  "success"
                );
                this.getIdpExamination()
              })
              .catch((error) => {
                this.$swal("Error", error.response.error, "error");
                console.error("Review failed:", error);
              });
          }
        }
      });
    },
    exportPdf() {
      this.$bvModal.show("modal-loading");
      axiosIns
        .get(`${axiosIns.defaults.baseURL}/idp-report?nik=${this.nik}`, {
          responseType: "blob"
        })
        .then((resp) => {
          // console.log(resp);
          const url = window.URL.createObjectURL(new Blob([resp.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `IDP-Report-${this.name}.pdf`);
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.$bvModal.hide("modal-loading");
        })
        .catch((resp) => {
          this.$swal("Error", `${resp.response.data.error}`, "error");
          this.$bvModal.hide("modal-loading");
        });
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    editProficiency(item) {
      console.log("isi row", item);
      this.isEditProficiency = true;
      this.bodyProficiency = {
        id: item.id,
        proficiency: item.proficiency_new,
        competency: item.competency_name,
        old_proficiency: item.proficiency,
        standartd_proficiency: item.proficiency_standard,
      };
    },
    submitEditProficiency() {
      let request = {
        id: this.bodyProficiency.id,
        data: {
          proficiency: Number(this.bodyProficiency.proficiency),
          feedback: this.bodyProficiency.feedback
        }
      };
      this.$store
        .dispatch("idpExamination/editDataIdpExamination", request)
        .then((response) => {
          this.$swal("Success", "Proficiency berhasil diubah", "success");
          this.isEditProficiency = false;
          this.getIdpExamination();
        })
        .catch((error) => {
          this.$swal(
            "Error",
            "Gagal mengubah proficiency: " +
              (error.response?.data?.message || error.message),
            "error"
          );
        });
    },
    getEmployee() {
      this.$store
        .dispatch("idpExamination/getEmployeeByManager", this.aboutMe.nik)
        .then((res) => {
          this.listEmployee = res.data;
        });
    },
    getIdpExamination() {
      this.$store
        .dispatch("idpExamination/getIdpExaminationByNik", this.nik)
        .then((res) => {
          const data = res.data.map((item) => ({
            ...item,
            isCompleted: item.items.some((i) => i.learning.status === 'completed')
          }));
          const groupedData = data.reduce(
            (acc, item) => {
              // Tambahkan kompetensi ke kategori "all"
              if (!acc.all) acc.all = [];
              let allCompetency = acc.all.find((c) => c.id === item.id);
              if (!allCompetency) {
                allCompetency = { ...item, items: [...item.items] };
                acc.all.push(allCompetency);
              }

              // Pisahkan berdasarkan idp_type
              item.items.forEach((learning) => {
                const type = learning.idp_type || "unknown";

                if (!acc[type]) {
                  acc[type] = [];
                }

                let existingCompetency = acc[type].find(
                  (c) => c.id === item.id
                );
                if (!existingCompetency) {
                  existingCompetency = { ...item, items: [] };
                  acc[type].push(existingCompetency);
                }

                existingCompetency.items.push(learning);
              });

              return acc;
            },
            { structured: [], social: [], experential: [], all: [] }
          );
          this.idpExamination = groupedData;
        });
    },
    selectEmployee(e) {
      this.nik = e?.employee_nik;
      this.name = e?.employee_name;
      this.position = e?.position_title;

      if (!this.nik) return

      this.bodySearch = {
        company: e?.company_name,
        directorate: e?.directorate,
        division: e?.division,
        department: e?.department
      }

      this.$store.dispatch("idpExamination/getIdpExaminationByNik", this.nik)
          .then((res) => {
          this.listDatainReview = res.data.filter(item => 
              item.status === 'Review'
              // item.items.some(i => i.learning.status === 'Review')
          )
          const data = res.data.map((item) => ({
            ...item,
            isCompleted: item.items.some((i) => i.learning.status === 'completed')
          }));
          const groupedData = data.reduce(
            (acc, item) => {
              // Tambahkan kompetensi ke kategori "all"
              if (!acc.all) acc.all = [];
              let allCompetency = acc.all.find((c) => c.id === item.id);

              if (!allCompetency) {
                allCompetency = { ...item, items: [...item.items] };
                acc.all.push(allCompetency);
              }
              // Pisahkan berdasarkan idp_type
              item.items.forEach((learning) => {
                const type = learning.idp_type || "unknown";
                if (!acc[type]) {
                  acc[type] = [];
                }
                let existingCompetency = acc[type].find(
                  (c) => c.id === item.id
                );
                if (!existingCompetency) {
                  existingCompetency = { ...item, items: [] };
                  acc[type].push(existingCompetency);
                }
                existingCompetency.items.push(learning);
              });
              return acc;
            },
            { structured: [], social: [], experential: [], all: [] }
          );          
          // console.log("grouped data=>",groupedData)
          this.idpExamination = groupedData;
        });
    },

    handleFileChange(event) {
      this.selectedFile = event.target.files[0];
    },
    showModalFeedback(item) {
      console.log("isi row buat feedback =>", item);

      const lastIndex = item.feedback.length - 1;
      this.bodyFeedback.id = item.feedback[0]?.id;
      this.bodyFeedback.summary = item.feedback[lastIndex].summary;
      this.bodyFeedback.follow_up = item.feedback[lastIndex].follow_up;
      this.bodyFeedback.feedback = item.feedback[lastIndex].feedback;

      this.isFeedbackSocial = true;
    },
    completedFeedback(item) {
      console.log("isi row buat feedback =>", item);

      const lastIndex = item.feedback.length - 1;
      this.bodyFeedback.id = item.feedback[0]?.id;
      this.bodyFeedback.summary = item.feedback[lastIndex].summary;
      this.bodyFeedback.follow_up = item.feedback[lastIndex].follow_up;
      this.bodyFeedback.feedback = item.feedback[lastIndex].feedback;

      this.feedbackCompleted = true;
    },
    saveSchedule() {
      const scheduleData = this.scheduleList.map((item) => ({
        date: this.$moment(item.date, "DD MMM YYYY").format("YYYY-MM-DD"),
        start_time: this.$moment(item.startTime, "HH:mm").format("HH:mm:ss+07"),
        end_time: this.$moment(item.endTime, "HH:mm").format("HH:mm:ss+07")
      }));

      const payload = {
        data: scheduleData
      };

      this.$store
        .dispatch("myIdp/createCoachingSchedule", {
          id: this.idIdpSocial,
          args: payload
        })
        .then((response) => {
          this.$swal("Success", "Jadwal berhasil disimpan", "success");
          this.isScheduleModalVisible = false;
          this.scheduleList = [];
          this.getScheduleSocial();
          this.getDataIdpManagerSocial();
        })
        .catch((error) => {
          this.$swal("Error", "Jadwal belum berhasil disimpan", "error");
          console.error("Error saving schedule:", error);
        });
    },
    addSchedule() {
      if (
        this.schedule.date &&
        this.schedule.startTime &&
        this.schedule.endTime
      ) {
        const formattedSchedule = {
          date: this.$moment(this.schedule.date).format("DD MMM YYYY"),
          startTime: this.$moment(this.schedule.startTime).format("HH:mm"),
          endTime: this.$moment(this.schedule.endTime).format("HH:mm")
        };
        this.scheduleList.push(formattedSchedule);
        this.clearScheduleModal();
        // this.isScheduleModalVisible = false;
      } else {
        this.$swal("Lengkapi semua kolom");
      }
    },
    removeSchedule(index) {
      this.scheduleList.splice(index, 1);
    },
    clearScheduleModal() {
      this.schedule = { date: null, startTime: null, endTime: null };
    },
    showScheduleModal() {
      this.isScheduleModalVisible = true;
    },
    getScheduleSocial() {
      this.$store
        .dispatch("myIdp/getSocialById", this.idIdpSocial)
        .then((res) => {
          this.scheduleSocial = res.data.schedule;
        });
    },
    setActualStartDate() {
      this.bodyEditActivities.actualStartDate = this.getCurrentDate();
    },

    setActualEndDate() {
      this.bodyEditActivities.actualEndDate = this.getCurrentDate();
    },
    formatDate(date) {
      if (!date) return "";
      return this.$moment(date).format("YYYY-MM-DD");
    },
    submitEditActivities() {
      const formData = new FormData();

      formData.append("id", this.bodyEditActivities.id);
      formData.append("task", this.bodyEditActivities.task);
      formData.append(
        "start_date",
        this.formatDate(this.bodyEditActivities.startDate)
      );
      formData.append(
        "end_date",
        this.formatDate(this.bodyEditActivities.endDate)
      );
      formData.append("percentage", this.bodyEditActivities.percentage);
      formData.append("status", this.bodyEditActivities.status);
      formData.append(
        "actual_start_date",
        this.formatDate(this.bodyEditActivities.actualStartDate)
      );
      formData.append(
        "actual_end_date",
        this.formatDate(this.bodyEditActivities.actualEndDate)
      );
      formData.append("progress", this.progressPercentage);

      // Attach the file if it exists
      if (this.selectedFile) {
        formData.append("files", this.selectedFile);
      }

      console.log("body edit", formData);

      this.$store
        .dispatch("myIdp/editProjectActivities", {
          id: this.bodyEditActivities.id,
          formData
        })
        .then((response) => {
          this.$swal(
            "Success",
            "Aktivitas proyek berhasil diubah",
            "success"
          );
          this.isEditActivities = false;
          this.getProjectActivities();
          this.clearBodyActivities();
        })
        .catch((error) => {
          this.$swal(
            "Error",
            "Gagal mengubah aktivitas: " +
              (error.response?.data?.message || error.message),
            "error"
          );
        });
    },
    completeActivities(item) {
      console.log("isinya", item);
      let idActivities = item.id;
      this.$swal({
        title: "Selesaikan Aktivitas",
        text: "Apakah Anda yakin ingin menyelesaikan aktivitas yang dipilih?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Ya"
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("myIdp/completeProjectActivities", idActivities)
            .then((response) => {
              this.$swal(
                "Selesai",
                "Aktivitas Anda telah diselesaikan.",
                "success"
              );
              this.getProjectActivities();
              this.getDataExperiential();
            })
            .catch((error) => {
              this.$swal("Error", "Aksi gagal. Silakan coba lagi.", "error");
              // console.error("Submission failed:", error);
            });
        }
      });
    },
    deleteActivities(item) {
      console.log("isinya", item);
      let idActivities = item.id;
      this.$swal({
        title: "Hapus Aktivitas",
        text: "Apakah Anda yakin ingin menghapus aktivitas yang dipilih?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Ya"
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("myIdp/deleteProjectActivities", idActivities)
            .then((response) => {
              this.$swal(
                "Terhapus",
                "Aktivitas Anda telah dihapus.",
                "success"
              );
              this.getProjectActivities();
            })
            .catch((error) => {
              this.$swal("Error", "Hapus gagal. Silakan coba lagi.", "error");
              // console.error("Submission failed:", error);
            });
        }
      });
    },
    editActivities(item) {
      console.log("isi row", item);
      this.milestone = item.milestone;

      this.bodyEditActivities.id = item.id;
      this.bodyEditActivities.task = item.task;
      this.bodyEditActivities.startDate = item.start_date;
      this.bodyEditActivities.endDate = item.end_date;
      this.bodyEditActivities.percentage = item.percentage;
      this.bodyEditActivities.status = item.status;
      this.bodyEditActivities.actualStartDate = item.actual_start_date;
      this.bodyEditActivities.actualEndDate = item.actual_end_date;
      this.progressPercentage = item.new_progress ? item.new_progress : "0";
      this.isEditActivities = true;
    },
    getBadgeGap(value) {
      if (value > 0) {
        return "badge bg-success";
      } else if (value < 0) {
        return "badge bg-danger";
      } else {
        return "badge bg-success";
      }
    },
    getBadgeResult(value, proficiency_standard) {
      if (value > proficiency_standard) {
        return "badge bg-success";
      } else if (value < proficiency_standard) {
        return "badge bg-danger";
      } else {
        return "badge bg-warning";
      }
    },
    getBadgeGapExam(value) {
      if (value > 0) {
        return "badge bg-danger";
      } else if (value < 0) {
        return "badge bg-success";
      } else if (value == 0) {
        return "badge bg-warning";
      } else {
        return "badge bg-success";
      }
    },
    updateCertificateUrl() {
      this.certificateUrl = `${axiosIns.defaults.baseURL}/certificate/${this.certificateName}`;
    },
    clearBodyActivities() {
      this.bodyActivities = {
        id: this.bodyActivities.id,
        id_learning: this.bodyActivities.id_learning,
        task: "",
        startDate: "",
        endDate: "",
        status: ""
      };
      this.bodyEditActivities = {
        task: "",
        startDate: "",
        endDate: "",
        status: "",
        actualStartDate: "",
        actualEndDate: ""
      };
    },
    getProjectActivities() {
      this.isLoading = true;
      this.$store
        .dispatch("myIdp/getProjectByUser", {
          id: this.bodyActivities.id_learning
        })
        .then((res) => {
          this.isLoading = false;
          this.dataActivities = res.data.activities;
        });
    },
    viewActivities(item) {
      console.log("data item", item);
      this.selectedRow = item;
      this.projectStatus = item.status;
      this.bodyActivities.id = item.id;
      this.bodyActivities.id_learning = item.id;
      this.getProjectActivities();
      this.isModalActivities = true;
    },
    approvalProject(item) {
      console.log("isi approval", item);
      this.bodyApproval.id = item.id;
      this.isModalApproval = true;
    },
    resetForm() {
      this.bodyAdd = {
        coaching: "",
        competency: "",
        provider: "",
        providerName: "",
        address: "",
        website: "",
        contactPerson: "",
        email: "",
        phone: "",
        trainingName: "",
        learningMethod: "",
        learningType: "",
        currency: "",
        price: "",
        description: ""
      };
      this.selectedLearning = null;
      this.$refs.modalTrainingAspiration.hide();
    },
    createTraining() {
      this.$swal({
        title: "Buat Pelatihan",
        text: "Apakah Anda yakin ingin membuat pelatihan ini?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Ya",
        cancelButtonText: "Batal"
      }).then((result) => {
        if (result.isConfirmed) {
          let requestData = {};

          if (this.bodyAdd.provider && this.selectedLearning) {
            requestData = {
              competency: this.bodyAdd.competency,
              provider: this.bodyAdd.provider,
              training: this.bodyAdd.training,
              nik: this.bodyAdd.nik
            };
          } else if (this.bodyAdd.provider && !this.selectedLearning) {
            requestData = {
              competency: this.bodyAdd.competency,
              provider: this.bodyAdd.provider,
              nik: this.bodyAdd.nik,
              training: {
                title: this.bodyAdd.trainingName,
                training_type: this.bodyAdd.learningType,
                training_method: this.bodyAdd.learningMethod,
                currency: this.bodyAdd.currency,
                price: this.bodyAdd.price,
                website: this.bodyAdd.websiteProvider,
                description: this.bodyAdd.description,
                hours: this.bodyAdd.hours
              }
            };
          } else if (!this.bodyAdd.provider && !this.selectedLearning) {
            requestData = {
              competency: this.bodyAdd.competency,
              nik: this.bodyAdd.nik,
              provider: {
                name: this.bodyAdd.providerName,
                address: this.bodyAdd.address,
                website: this.bodyAdd.websiteProvider,
                contact_person: this.bodyAdd.contactPerson,
                email: this.bodyAdd.email,
                phone: this.bodyAdd.phone
              },
              training: {
                title: this.bodyAdd.trainingName,
                training_type: this.bodyAdd.learningType,
                training_method: this.bodyAdd.learningMethod,
                currency: this.bodyAdd.currency,
                price: this.bodyAdd.price,
                website: this.bodyAdd.websiteTraining,
                description: this.bodyAdd.description,
                hours: this.bodyAdd.hours
              }
            };
          }
          // console.log("req data => ",requestData)
          this.$store
            .dispatch("myIdp/createStructuredLearning", requestData)
            .then((response) => {
              this.$swal
                .fire({
                  icon: "success",
                  title: "Success",
                  text: "Aspirasi pelatihan berhasil dibuat."
                })
                .then(() => {
                  // this.$refs.modalTrainingAspiration.hide();
                  this.getDataIdpManager();
                  this.getDataIdpManagerSocial();
                  this.getDataExperiential();
                  this.resetForm();
                });
            })
            .catch((error) => {
              this.$swal.fire({
                icon: "error",
                title: "Error",
                text: "Terjadi kesalahan saat membuat aspirasi pelatihan."
              });
            });
        }
      });
    },
    selectTraining(training) {
      if (training) {
        this.bodyAdd.learningMethod = training.training_method;
        this.bodyAdd.learningType = training.training_type;
        this.bodyAdd.currency = training.currency;
        this.bodyAdd.price = training.price;
        this.bodyAdd.trainingName = training.title;
        this.bodyAdd.websiteTraining = training.website;
        this.bodyAdd.description = training.description || "";
      } else {
        this.bodyAdd.learningMethod = null;
        this.bodyAdd.learningType = null;
        this.bodyAdd.currency = "IDR";
        this.bodyAdd.price = null;
        this.bodyAdd.trainingName = "";
        this.bodyAdd.websiteTraining = "";
        this.bodyAdd.description = "";
      }
    },
    selectProvider(selectedProviderId) {
      const selectedProvider = this.dataProvider.find(
        (provider) => provider.id === selectedProviderId
      );
      if (selectedProvider) {
        this.bodyAdd.providerName = selectedProvider.providerName;
        this.bodyAdd.address = selectedProvider.address;
        this.bodyAdd.websiteProvider = selectedProvider.website;
        this.bodyAdd.contactPerson = selectedProvider.contactPerson;
        this.bodyAdd.email = selectedProvider.email;
        this.bodyAdd.phone = selectedProvider.phone;
      }
    },
    async searchTraining(search) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(async () => {
        if (search.length >= 2 && this.bodyAdd.provider) {
          try {
            await this.$store.dispatch(
              "trainingProvider/getTrainingByProvider",
              {
                providerId: this.bodyAdd.provider,
                search
              }
            );
            this.dataTraining =
              this.$store.state.trainingProvider.trainingByProvider;
          } catch (err) {
            console.error(err);
            this.dataTraining = [];
          }
        } else {
          this.dataTraining = [];
        }
      }, 300);
    },
    formatDateTable(date) {
      if (!date || !this.$moment(date).isValid()) {
        return "-";
      }
      return this.$moment(date).format("DD-MM-YYYY");
    },
    getProjectByUser() {
      this.isLoading = true;
      this.$store
        .dispatch("project/getProjectByUser", { nik: this.bodyAssign.nik })
        .then((res) => {
          this.isLoading = false;

          this.projectData = res.data;
          // this.updateCheckedRoles()
        });
    },
    getProjectByUserNik() {
      this.isLoading = true;
      this.$store
        .dispatch("myIdp/getProjectByNik", { nik: this.bodyFeedback.nik })
        .then((res) => {
          this.isLoading = false;
          this.projectUser = res.data;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          this.isLoading = false;
        });
    },
    updateCheckedRoles() {
      this.checkedRoles = {};

      this.projectData.forEach((item) => {
        item.roles.forEach((role) => {
          role.assignee.forEach((assignee) => {
            this.$set(
              this.checkedRoles,
              `${item.project_id}-${role.project_role_name}`,
              true
            );
          });
        });
      });
    },

    downloadCertificate() {
      let datas = `${axiosIns.defaults.baseURL}/certificate/${this.certificateName}`;
      window.open(datas);
    },
    submitApproval() {
      // const idActivities = item.id;
      // const status =this.bodyApproval.status
      this.$swal({
        title: "Ubah Status Proyek",
        text: `Apakah Anda yakin ingin mengubah status proyek?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Ya"
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("myIdp/updateProjectStatus", {
              id: this.bodyApproval.id,
              status: this.bodyApproval.status,
              notes: this.bodyApproval.notes
            })
            .then((response) => {
              this.$swal(
                "Tersimpan",
                `Status proyek telah diubah.`,
                "success"
              );
              this.getDataExperiential();
              this.bodyApproval.notes = "";
              this.bodyApproval.status = "";
              this.isModalApproval = false;
            })
            .catch((error) => {
              console.error("Error details:", error);
              this.$swal("Error", "Simpan gagal. Silakan coba lagi.", "error");
            });
        }
      });
    },
    submitFeedback() {
      let data = {
        id: this.bodyFeedback.id,
        feedback: this.bodyFeedback.feedback
      };
      console.log("payload feedback=>", data);
      this.$store
        .dispatch("myIdp/addFeedbackExamination", data)
        .then((response) => {
          this.$swal
            .fire({
              icon: "success",
              title: "Success",
              text: "Umpan balik berhasil ditambahkan."
            })
            .then(() => {
              this.getIdpExamination();

              this.isModalFeedbackActivities = false;

              this.bodyFeedback.feedback = "";
            });
        })
        .catch((error) => {
          console.log(error);
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "Terjadi kesalahan saat menambah umpan balik examination."
          });
        });
    },
    submitFeedbackSocial() {
      let data = {
        id: this.bodyFeedback.id,
        feedback: this.bodyFeedback.feedback
      };
      this.$store
        .dispatch("myIdp/addFeedbackCoaching", data)
        .then((response) => {
          this.$swal
            .fire({
              icon: "success",
              title: "Success",
              text: "Umpan balik berhasil ditambahkan."
            })
            .then(() => {
              this.getDataIdpManagerSocial();
              this.getScheduleSocial();
              this.isFeedbackSocial = false;
              this.bodyFeedback.id = "";
              this.bodyFeedback.feedback = "";
            });
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "Terjadi kesalahan saat menambah umpan balik aktivitas."
          });
        });
    },
    submitScoreStructured() {
      console.log("idnya", this.bodyScoreStructured.id);
      this.$store
        .dispatch("myIdp/updateScoreStructuredLearning", {
          id: this.bodyScoreStructured.id,
          score: this.bodyScoreStructured.score,
          feedback: this.bodyScoreStructured.feedback
        })
        .then((response) => {
          this.$swal.fire("Success", "Skor berhasil diperbarui", "success");
          this.isModalScoreStructured = false;
          this.clearUpdateStructured();
          this.getDataIdpManager();
          this.getDataIdpManagerSocial();
        })
        .catch((error) => {
          this.$swal.fire(
            "Error",
            "Gagal memperbarui skor: " +
              (error.response?.data?.message || error.message),
            "error"
          );
        });
    },
    submitAssignee() {
      const data = [];

      this.projectData.forEach((item) => {
        item.roles.forEach((role) => {
          if (
            this.checkedRoles[item.project_id + "-" + role.project_role_name]
          ) {
            data.push({
              project_id: item.project_id,
              role_id: role.project_role_id,
              nik: this.bodyAssign.nik
            });
          }
        });
      });

      // Structure the payload
      const payload = {
        data: data
      };

      this.$store
        .dispatch("myIdp/assignProject", payload)
        .then((response) => {
          this.$swal.fire("Success", "Proyek berhasil di-assign", "success");
          this.isModalAssign = false;
          this.getDataIdpManager();
          this.getDataIdpManagerSocial();
          this.getDataExperiential();
          this.checkedRoles = {};
        })
        .catch((error) => {
          this.$swal.fire(
            "Error",
            "Gagal assign proyek: " +
              (error.response?.data?.message || error.message),
            "error"
          );
        });
    },
    submitScoreSocial() {
      this.$store
        .dispatch("myIdp/assignProject", {
          id: this.bodyScoreSocial.id,
          score: this.bodyScoreSocial.score,
          feedback: this.bodyScoreSocial.feedback
        })
        .then((response) => {
          this.$swal.fire("Success", "Skor berhasil diperbarui", "success");
          this.isModalScoreSocial = false;
          this.clearUpdateSocial();
          this.getDataIdpManager();
          this.getDataIdpManagerSocial();
        })
        .catch((error) => {
          this.$swal.fire(
            "Error",
            "Gagal memperbarui skor: " +
              (error.response?.data?.message || error.message),
            "error"
          );
        });
    },
    clearUpdateStructured() {
      (this.bodyScoreStructured.id = ""),
        (this.bodyScoreStructured.score = ""),
        (this.bodyScoreStructured.feedback = "");
    },
    clearUpdateSocial() {
      (this.bodyScoreSocial.id = ""),
        (this.bodyScoreSocial.score = ""),
        (this.bodyScoreSocial.feedback = "");
    },
    addScoreStructured(item) {
      // console.log("item", item);
      this.bodyScoreStructured.id = item.id;
      this.isModalScoreStructured = true;
    },
    assignProject(item) {
      console.log("isinya ngab", item);
      this.bodyAssign.nik = item.employee_nik;
      this.getProjectByUser();
      this.isModalAssign = true;
    },
    addFeedback(item) {
      console.log("isi row exam", item);
      this.bodyFeedback.id = item.id;
      this.isModalFeedbackActivities = true;
    },
    viewFeedback(item) {
      console.log("isi row exam", item);
      // this.bodyFeedback.id = item.id;
      // this.bodyFeedback.viewFeedback = item.feedback;
      this.bodyProficiencyView = {
        id: item.id,
        proficiency: item.proficiency_new,
        competency: item.competency_name,
        old_proficiency: item.proficiency,
        standartd_proficiency: item.proficiency_standard,
        feedback: item.feedback
      };
      this.isModalViewFeedback = true;
    },
    viewProjectList(item) {
      this.bodyFeedback.nik = item.employee_nik;
      console.log("kaskdjqwd", this.bodyFeedback.nik);
      this.getProjectByUserNik();
      this.isModalFeedback = true;
      console.log("isinya", item);
    },
    addScoreSocial(item) {
      // console.log("item", item);
      this.bodyScoreSocial.id = item.id;
      this.isModalScoreSocial = true;
    },
    isCheckboxProject() {
      return true;
    },
    isCheckboxVisible(status) {
      return (
        status !== "approved" &&
        status !== "enrolled" &&
        status !== "kosong" &&
        status !== null &&
        status !== "completed" &&
        status !== "in_review" &&
        status !== "closed"
      );
    },
    preselectRows() {
      this.srStructuredLearning = this.structuredLearning
        .filter(
          (item) => item.status === "draft" || item.status === "submitted"
        )
        .map((item) => item.id);
      this.srSocialLearning = this.socialLearning
        .filter(
          (item) => item.status === "draft" || item.status === "submitted"
        )
        .map((item) => item.id);
    },
    viewDetailStructured(row) {
      this.selectedRowStructured = row;
      this.certificateName = row.certificate;
      this.isModalStructured = true;
      this.updateCertificateUrl();
    },
    viewDetailSocial(row) {
      this.idIdpSocial = row.id;
      this.selectedRowSocial = row;
      // this.certificateName = row.certificate;
      this.isModalSocial = true;
      this.getScheduleSocial();
    },
    clearSelectedRow() {
      this.selectedRowStructured = null;
      this.selectedRowSocial = null;
    },

    getCompetency() {
      this.$store.dispatch("competency/getDataCompetencyByNik").then((res) => {
        this.dataCompetency = res.data;
      });
    },
    formatTime(time) {
      return this.$moment(time, "HH:mm:ssZ").format("HH:mm");
    },
    getTrainingMethod() {
      this.$store.dispatch("trainingMethod/getTrainingMethod").then((res) => {
        // console.log("trainMe", res.data);
        this.dataTrainingMethod = res.data;
      });
    },
    getTrainingType() {
      this.$store.dispatch("trainingType/getTrainingType").then((res) => {
        // console.log("trainType", res.data);
        this.dataTrainingType = res.data;
      });
    },
    getProvider() {
      this.$store
        .dispatch("trainingProvider/getTrainingProviders")
        .then((res) => {
          this.dataProvider = res.data;
        });
    },
    getDataIdpManager() {
      this.isLoading = true;
      this.$store
        .dispatch("myIdp/getIdpManager")
        .then((res) => {
          const dataArray = res.data;
          this.dataEmployee = dataArray.map((employee) => ({
            employee_name: employee.employee_name,
            employee_nik: employee.employee_nik
          }));

          this.structuredLearning = dataArray.flatMap((data, dataIndex) => {
            const employeeName = data.employee_name;
            const competencies = data.competency;

            return competencies.flatMap((comp, compIndex) => {
              const gap =
                comp.proficiency > comp.proficiency_standard
                  ? comp.proficiency - comp.proficiency_standard
                  : comp.proficiency < comp.proficiency_standard
                  ? -(comp.proficiency_standard - comp.proficiency)
                  : 0;
              const baseComp = {
                competency: comp.competency || null,
                proficiency: comp.proficiency || null,
                proficiency_standard: comp.proficiency_standard || null,
                gap: gap,
                difference: comp.difference || null,
                training_title: null,
                score: null,
                feedback: null,
                proposed_by: null,
                certificate: comp.certificate || null,
                status: null,
                id: null,
                idp_id: null,
                training_type: null,
                training_provider: null,
                price: null,
                training_method: null,
                training_hours: comp.training_hours || null
              };

              const isFirstCompetency = dataIndex === 0 && compIndex === 0;
              const isFirstInSet = dataIndex > 0 && compIndex === 0;

              if (
                comp.structured_learning &&
                comp.structured_learning.length > 0
              ) {
                const firstLearningItem = comp.structured_learning[0];
                return [
                  {
                    ...baseComp,
                    competency: comp.competency,
                    training_title: firstLearningItem.training_title,
                    score: firstLearningItem.score,
                    feedback: firstLearningItem.feedback,
                    proposed_by: firstLearningItem.proposed_by,
                    status: firstLearningItem.status,
                    certificate: firstLearningItem.certificate || null,
                    id: firstLearningItem.id,
                    idp_id: firstLearningItem.idp_id,
                    training_type: firstLearningItem.training_type,
                    training_provider: firstLearningItem.training_provider,
                    price: firstLearningItem.training_price,
                    training_method: firstLearningItem.training_method,
                    training_hours: firstLearningItem.training_hours,
                    employee_name:
                      isFirstCompetency || isFirstInSet ? employeeName : null
                  },
                  ...comp.structured_learning.slice(1).map((sl) => ({
                    ...baseComp,
                    competency: null,
                    training_title: sl.training_title,
                    score: sl.score,
                    feedback: sl.feedback,
                    proposed_by: sl.proposed_by,
                    certificate: sl.certificate || null,
                    status: sl.status,
                    id: sl.id,
                    idp_id: sl.idp_id,
                    training_type: sl.training_type,
                    training_provider: sl.training_provider,
                    price: sl.training_price,
                    training_method: sl.training_method,
                    training_hours: sl.training_hours,
                    employee_name: null
                  }))
                ];
              } else {
                return [
                  {
                    ...baseComp,
                    employee_name:
                      isFirstCompetency || isFirstInSet ? employeeName : null
                  }
                ];
              }
            });
          });

          this.isEmpty =
            !this.structuredLearning || this.structuredLearning.length === 0;
          this.preselectRows();
          this.isLoading = false;
          // console.log("structured learning=> ", this.structuredLearning);
        })
        .catch((error) => {
          console.error("Error fetching idp data:", error);
          this.isLoading = false;
          this.isEmpty = true;
        });
    },

    getDataIdpManagerSocial() {
      this.isLoading = true;
      this.$store
        .dispatch("myIdp/getIdpManager")
        .then((res) => {
          const dataArray = res.data;

          const socialLearningMap = new Map();

          let previousEmployeeName = null;

          dataArray.forEach((data) => {
            const employeeName = data.employee_name;

            if (!socialLearningMap.has(employeeName)) {
              socialLearningMap.set(employeeName, []);
            }

            data.social_learning.forEach((exp) => {
              exp.competency.forEach((comp, index) => {
                const gap =
                  comp.proficiency > comp.proficiency_standard
                    ? comp.proficiency - comp.proficiency_standard
                    : comp.proficiency < comp.proficiency_standard
                    ? -(comp.proficiency_standard - comp.proficiency)
                    : 0;

                const employeeNameToDisplay =
                  previousEmployeeName !== employeeName ? employeeName : null;

                socialLearningMap.get(employeeName).push({
                  competency: comp.name,
                  proficiency: comp.proficiency,
                  proficiency_standard: comp.proficiency_standard,
                  difference: gap,
                  id: index === 0 ? exp.id : null,
                  idp_id: index === 0 ? exp.idp_id : null,
                  coaching_id: index === 0 ? exp.coaching_id : null,
                  coaching_title: index === 0 ? exp.coaching_title : null,
                  coaching_methodology:
                    index === 0 ? exp.coaching_methodology : null,
                  coach_name: index === 0 ? exp.coach_name : null,
                  coaching_hour: index === 0 ? exp.coaching_hour : null,
                  status: index === 0 ? exp.status : null,
                  employee_name: employeeNameToDisplay
                });

                if (employeeNameToDisplay) {
                  previousEmployeeName = employeeName;
                }
              });
            });
          });

          this.socialLearning = Array.from(socialLearningMap.values()).flat();

          this.isEmpty =
            !this.socialLearning || this.socialLearning.length === 0;
          this.preselectRows();
          this.isLoading = false;
        })
        .catch((error) => {
          console.error("Error fetching social learning data:", error);
          this.isLoading = false;
          this.isEmpty = true;
        });
    },

    getDataExperiential() {
      this.isLoading = true;
      this.$store
        .dispatch("myIdp/getIdpManager")
        .then((res) => {
          const dataArray = res.data;

          this.dataEmployee = dataArray.map((employee) => ({
            employee_name: employee.employee_name,
            employee_nik: employee.employee_nik
          }));

          this.experientialLearning = dataArray.flatMap((data, dataIndex) => {
            const employeeName = data.employee_name;
            const experientialLearningItems = data.experential_learning;

            return experientialLearningItems.flatMap((exp, expIndex) => {
              const baseExp = {
                id: exp.id,
                status: exp.status,
                project_id: exp.project_id,
                notes: exp.notes,
                competency: exp.competency,
                attachments: exp.project?.attachments || null,
                id_project: exp.project?.id || null,
                name: exp.project?.name || null,
                description: exp.project?.description || null,
                start_date: exp.project?.start_date || null,
                end_date: exp.project?.end_date || null,
                duration: exp.project?.duration || null,
                involment: exp.project?.involment || null,
                subordinate: exp.project?.subordinate || null,
                business_need: exp.project?.business_need || null,
                objectives: exp.project?.objectives || null,
                goals: exp.project?.goals || null,
                scope: exp.project?.scope || null,
                constraints: exp.project?.constraints || null,
                deliverables: exp.project?.deliverables || null,
                impact_a: exp.project?.impact_a || null,
                impact: exp.project?.impact || null,
                impact_b: exp.project?.impact_b || null,
                attachments: exp.project?.attachments || null,
                created_at: exp.created_at
              };

              const isFirstExperiential = dataIndex === 0 && expIndex === 0;
              const isFirstInSet = dataIndex > 0 && expIndex === 0;

              if (exp) {
                const firstProjectItem = exp.project;
                return [
                  {
                    ...baseExp,
                    employee_name:
                      isFirstExperiential || isFirstInSet ? employeeName : null
                  }
                ];
              } else {
                return [
                  {
                    ...baseExp,
                    employee_name:
                      isFirstExperiential || isFirstInSet ? employeeName : null
                  }
                ];
              }
            });
          });

          this.isEmpty =
            !this.experientialLearning ||
            this.experientialLearning.length === 0;
          this.preselectRows();
          this.isLoading = false;
        })
        .catch((error) => {
          console.error("Error fetching experiential learning data:", error);
          this.isLoading = false;
          this.isEmpty = true;
        });
    },

    initStructuredLearning() {
      this.$store
        .dispatch("myidp/initIdpStructuredLearning")
        .then((res) => {
          // console.log("isi res", res);
          this.getDataIdpManager();
          this.getDataIdpManagerSocial();
        })
        .catch((error) => {
          console.error("Error fetching idp data:", error);
        });
    },

    getBadgeSummary(value) {
      if (value === "Completed") {
        return "badge bg-success";
      } else if (value === "In Progress") {
        return "badge bg-warning";
      }
    },
    getBadgeStatus(value) {
      // const status = value.toLowerCase();
      if (value === "completed") {
        return "badge bg-success";
      } else if (value === "draft") {
        return "badge bg-warning";
      } else if (value === "registered") {
        return "badge bg-secondary";
      } else if (value === "rejected") {
        return "badge bg-danger";
      } else if (value === "submitted") {
        return "badge bg-success";
      } else if (value === "approved") {
        return "badge bg-success";
      } else if (value === "enrolled") {
        return "badge bg-success";
      } else if (value === "completed") {
        return "badge bg-info";
      } else if (value === "assigned") {
        return "badge bg-success";
      } else if (value === "to do") {
        return "badge bg-danger";
      } else if (value === "in review") {
        return "badge bg-info";
      } else if (value === "closed") {
        return "badge bg-secondary";
      } else if (value === "revision") {
        return "badge bg-danger";
      } else if (value === "in progress") {
        return "badge bg-warning";
      } else if (value === "scheduled") {
        return "badge bg-warning";
      } else if (value === "enrollment pending") {
        return "badge bg-warning";
      } else if (value === "proposed") {
        return "badge bg-info";
      } else if (value === "process") {
        return "badge bg-warning";
      } else if (value === "Review") {
        return "badge bg-info";
      }
      return "";
    },
    getIconClass(value) {
      if (!value) return "";
      const status = value.toLowerCase();
      switch (status) {
        case "completed":
          return "fe fe-check-circle";
        case "draft":
          return "fe fe-file-text";
        case "registered":
          return "fe fe-user-check";
        case "rejected":
          return "fe fe-x";
        case "submitted":
          return "fe fe-send";
        case "approved":
          return "fe fe-check";
        case "enrolled":
          return "fe fe-user-plus";
        case "assigned":
          return "fe fe-user-check";
        case "in progress":
        case "in_progress":
          return "fe fe-loader";
        case "to do":
        case "to_do":
          return "fe fe-list";
        case "active":
          return "fe fe-activity";
        case "in review":
          return "fe fe-eye";
        case "closed":
          return "fe fe-lock";
        case "submit":
          return "fe fe-arrow-up-circle";
        case "revision":
          return "fe fe-edit";
        case "scheduled":
          return "fe fe-calendar";
        case "enrollment_pending":
          return "fe fe-loader";
        case "proposed":
          return "fe fe-loader";
        case "process":
          return "fe fe-loader";
        case "review":
          return "fe fe-eye";
        default:
          return "";
      }
    },
    capitalizeStatus(value) {
      if (!value) {
        return null;
      }
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    },

    linkPresentation(link) {
      return `${axiosIns.defaults.baseURL}/presentation/${link}`;
    },

    completeLearning() {
      this.$swal({
        title: "Kirim Coaching?",
        text: "Apakah Anda yakin ingin mengirim coaching ini?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Kirim",
        cancelButtonText: "Batal"
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("myIdp/completeReviewSocial", {
              id: this.selectedRowSocial.id
            })
            .then((resp) => {
              this.isModalSocial = false;
              this.getDataIdpManager();
              this.getDataIdpManagerSocial();
              this.getDataExperiential();
              this.getCompetency();
              this.getProvider();
              this.getTrainingMethod();
              this.getTrainingType();
            })
            .catch((err) => {
              this.$swal(`Gagal`, err.response.data.error, "error");
            });
        }
      });
    },

    formatPrice(price) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(price);
    },
    confirmSubmissionStructured() {
      const approved = this.approvedItems.map((item) => item.id);
      const rejected = this.rejectedItems.map((item) => item.id);
      const reqBody = {
        id: approved,
        reject_id: rejected
      };

      this.$store
        .dispatch("myIdp/approveStructuredLearning", reqBody)
        .then((response) => {
          this.$swal(
            "Disetujui",
            "Pembelajaran Anda telah disetujui.",
            "success"
          );
          this.$refs.confirmationModalStructured.hide();
          this.getDataIdpManager();
          this.getDataIdpManagerSocial();
        });
    },
    confirmSubmissionSocial() {
      // console.log("apasps",this.approvedItems)
      // console.log("rejected",this.rejectedItems)
      const approved = this.approvedItemsSocial.map((item) => item.id);
      const rejected = this.rejectedItemsSocial.map((item) => item.id);
      const reqBody = {
        id: approved,
        reject_id: rejected
      };
      this.$store
        .dispatch("myIdp/approveSocialLearning", reqBody)
        .then((response) => {
          this.$swal(
            "Disetujui",
            "Pembelajaran Anda telah disetujui.",
            "success"
          );
          this.$refs.confirmationModalSocial.hide();
          this.getDataIdpManager();
          this.getDataIdpManagerSocial();
        });
    },
    submitStructured() {
      const cleanedSelectedRows = this.sRowStructured?.filter(
        (id) => typeof id === "number" && id !== null
      );
      const preselectedRows = this.srStructuredLearning.filter(
        (id) => typeof id === "number" && id !== null
      );
      this.approvedItems = this.structuredLearning.filter((item) =>
        cleanedSelectedRows?.includes(item.id)
      );
      this.rejectedItems = this.structuredLearning.filter(
        (item) =>
          preselectedRows.includes(item.id) &&
          !cleanedSelectedRows?.includes(item.id) &&
          item.id !== null &&
          (item.status === "submitted" || item.status === "draft")
      );

      this.$refs.confirmationModalStructured.show();
    },
    submitSocial() {
      const cleanedSelectedRows = this.sRowSocial?.filter(
        (id) => typeof id === "number" && id !== null
      );
      const preselectedRows = this.srSocialLearning.filter(
        (id) => typeof id === "number" && id !== null
      );
      this.approvedItemsSocial = this.socialLearning.filter((item) =>
        cleanedSelectedRows?.includes(item.id)
      );
      this.rejectedItemsSocial = this.socialLearning.filter(
        (item) =>
          preselectedRows.includes(item.id) &&
          !cleanedSelectedRows?.includes(item.id) &&
          item.id !== null &&
          (item.status === "submitted" || item.status === "draft")
      );
      this.$refs.confirmationModalSocial.show();
    }
  },
  mounted() {
    this.getEmployees();
    // this.getEmployee();
    this.getDataIdpManager();
    this.getDataIdpManagerSocial();
    this.getDataExperiential();
    this.getCompetency();
    this.getProvider();
    this.getTrainingMethod();
    this.getTrainingType();
    this.getBusinessUnit();

    const listMenu = JSON.parse(localStorage.getItem('listMenu') || [])
    const currentPath = window.location.pathname; // Path dari URL saat ini
    const menu = listMenu.find((menu) =>
      menu.link === String(currentPath) || menu.children.some((child) => child.link === String(currentPath))
    );
    this.listTabMenu = menu;
  }
};
</script>

<style>
.pagination-controls {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 5px;
  margin-top: 15px;
}
.pagination-controls label {
  margin-right: 10px;
}
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}
.pagination button {
  margin: 0 5px;
}
.table-responsive::-webkit-scrollbar {
  display: none; /* For Chrome, Safari, and Opera */
}
.table-responsive {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.rectangle-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.5px;
}
.rectangle {
  width: 15px;
  height: 10px;
  background-color: #e0e0e0;
  border: 1px solid #ccc;
}
.rectangle.filled-danger {
  background-color: #e63757;
}
.rectangle.filled-target {
  background-color: #f6c343;
}
.rectangle.filled-achievement {
  background-color: #00d97e;
}
</style>
